const PT = {
  // Generic actions
  'action:accept': 'Aceitar',
  'action:return': 'Voltar',
  'action:go-to-home': 'Ir para o início',
  'action:enter': 'Entrar',
  'action:close': 'Fechar',
  'action:login': 'Iniciar sessão',
  'action:search': 'Pesquisar',
  'action:logout': 'Terminar sessão',
  'action:change': 'Alterar',
  'action:request-shipment': 'Solicitar envio',
  'action:download-excel-selection': 'Descarregar seleção',
  'action:visualise-selection': 'Ver seleção',
  'action:use-new-address': 'Quero utilizar uma nova morada',
  'action:save-address-my-agenda': 'Guardar morada na minha agenda',
  'action:delete-address-my-agenda-header': 'Apagar contacto',
  'action:delete-created-address-header': 'Apagar contacto',
  'action:delete-created-address-body':
    'Tem a certeza de que pretende apagar este contacto da sua agenda?',
  'action:delete-created-address-header-2': 'Apagar morada',
  'action:delete-created-address-body-2':
    'Esta morada não está guardada na sua agenda. Pretende apagá‑la?',
  'action:delete-addresses-my-agenda-header': 'Apagar contactos',
  'action:delete-address-my-agenda-body':
    'Tem a certeza de que pretende apagar este contacto da sua agenda?',
  'action:delete-addresses-my-agenda-body':
    'Vai apagar {number} contactos da sua agenda. Se o fizer, não será possível recuperá‑los.',
  'action:delete-address-my-agenda-body-success':
    'O contacto foi apagado com sucesso.',
  'action:delete-address-my-agenda-body-error':
    'Não foi possível apagar o contacto. Tente novamente.',
  'action:delete-addresses-my-agenda-body-success':
    'Os contactos foram apagados com sucesso.',
  'action:retry': 'Tentar novamente',
  'action:back-to-agenda-address': 'Voltar à morada por defeito',
  'action:back-to-home': 'Voltar à página inicial',
  'action:go-to-previous-page': 'Voltar à página anterior',
  'action:reload-page': 'Recarregar esta página',
  'action:want-choose-day-time': 'Quero escolher outro dia e hora',
  'action:want-choose-day-and-time': 'Quero escolher dia e hora',
  'action:as-soon-as-possible': 'O mais cedo possível',
  'action:request-later': 'Vou solicitar mais tarde',
  'action:unscheduled-date': 'Sem agendamento',
  'action:discard': 'Descartar',
  'action:discard-changes': 'Descartar alterações',
  'action:cancel': 'Cancelar',
  'action:exit': 'Sair',
  'action:abandon-process': 'Sair do processo',
  'action:delete-contacts': 'Apagar {contacts}',
  'action:cancel-shipment':
    'Anular {count, plural, one {envio} other {envios}}',
  'action:duplicate-shipment': 'Duplicar envio',
  'action:activate-return': 'Solicitar devolução',
  'action:return-shipping': 'Devolver envio',
  'action:upload-files': 'Escolha ou arraste um ficheiro para importar',
  'action:allowed-files':
    'Formatos permitidos: .XLSX, .CSV. Tamanho máximo permitido: 5 MB.',
  'action:uploading-files': 'A carregar ficheiro…',
  'action:download': 'Descarregar',
  'action:label': 'Etiqueta',
  'action:procesing': 'A processar',
  'action:download-2': 'Descarregar',
  'action:download-pod': 'Descarregar POD',
  'action:download-albaran': 'Descarregar guia',
  'action:import-file': 'Importação em massa',
  'action:import-files': 'Importar envios',
  'action:importation-files': 'Importação de envios',
  'action:one-shipment': 'Um envio',
  'action:import-contacts': 'Importar contactos',
  'action:schedule-pickup': 'Agendar recolha',
  'action:download-shipping-label':
    'Descarregar {count, plural, one {etiqueta} other {etiquetas}}',
  'action:print-shipping-label':
    'Imprimir {count, plural, one {etiqueta} other {etiquetas}}',
  'action:print': 'Imprimir',
  'action:go-to-next-error': 'Ir para o erro seguinte',
  'action:next-step': 'Separador seguinte',
  'action:add-destination': 'Adicionar destino',
  'action:save': 'Guardar',
  'action:save-changes': 'Guardar alterações',
  'action:submit-from': 'Continuar',
  'action:submit-to': 'Continuar',
  'action:confirm': 'Confirmar',
  'action:confirm-changes': 'Confirmar alterações',
  'action:submit-shipment': 'Continuar',
  'action:submit-customs': 'Continuar',
  'action:continue-importation': 'Continuar com a importação',
  'action:submit-services': 'Ver resumo do meu pedido',
  'action:submit-summary': 'Guardar e/ou imprimir etiqueta',
  'action:submit-summary-origin-pickup-point': 'Guardar',
  'action:fix-errors': 'Corrigir erros',
  'action:choose-direction-from-agenda': 'Escolher uma morada da minha agenda',
  'action:new-address': 'Criar uma nova morada',
  'action:choose-another-direction-from-list':
    'Escolher uma morada da minha agenda',
  'action:select-direction': 'Escolher esta morada',
  'action:select-locality': 'Selecionar localidade',
  'action:file-type': 'Tipo de ficheiro',
  'action:download-label': 'Descarregar etiqueta',
  'action:change-data': 'Quero alterar estes dados',
  'action:add-package': 'Adicionar um novo volume',
  'action:add-item': 'Adicionar artigo',
  'action:remove-item': 'Apagar artigo',
  'action:shipment-tracking': 'Seguir envio',
  'action:execute-action': 'Executar ação',
  'action:apply-filters': 'Aplicar filtros',
  'action:clean-filters': 'Limpar filtros',
  'action:select-and-continue': 'Selecionar e continuar',
  'action:download-xlsx': 'Descarregar em xlsx',
  'action:send-me-the-code': 'Enviem-me o código',
  'action:save-my-new-password': 'Guardar a minha nova palavra-passe',
  'action:request-a-shipment': 'Criar um envio',
  'action:request-a-shipment-first': 'Quero fazer o meu primeiro envio agora',
  'action:back': 'Voltar',
  'action:see-normative': 'Ver normativa',
  'action:click-text-copied': 'Texto copiado',
  'action:text-copied': 'Clique para copiar',
  'action:new-shipping': 'Solicitar outro envio',
  'action:new-shipping-2': 'Solicitar novo envio',
  'action:download-pdf': 'Descarregar PDF',
  'action:download-app': 'Descarregar App',
  'action:yes-logout': 'Sim, terminar sessão',
  'action:back-home': 'Voltar ao início',
  'action:export-excel': 'Exportar para Excel',
  'action:change-delivery-point': 'Alterar ponto de recolha',
  'noun:delivery-point:error': 'Erro',
  'action:understood': 'Percebi',
  'noun:actionButtons': 'Ações',
  'noun:status': 'Estado',
  'noun:agenda': 'A minha agenda',
  'noun:important': 'Importante',
  'action:export-csv': 'Exportar para CSV',
  'action:remove-contact': 'Apagar contacto',
  'action:remove-contacts': 'Apagar {contacts} contactos',
  'action:export-contact': 'Exportar contacto',
  'action:export-contacts': 'Exportar contactos',
  'action:duplicate': 'Duplicar',
  'action:delete': 'Remover',

  // Punto de entrega
  'delivery-point:list:no-results':
    'Utilize a pesquisa para obter pontos de entrega.',

  // Generic nouns
  'noun:user': 'Utilizador',
  'noun:password': 'Palavra-passe',
  'noun:reason': 'Motivo do pedido',
  'noun:comments-detail': 'Descreva o seu pedido',
  'noun:my-new-password': 'A minha nova palavra-passe',
  'noun:new-password': 'Nova palavra-passe',
  'noun:current-password': 'Palavra-passe atual',
  'noun:code': 'Código',
  'noun:route': 'Morada',
  'noun:tracking': 'Seguimento',
  'noun:recording': 'Ficheiro de envios',
  'noun:incidents': 'Incidentes',
  'noun:page': 'Página',
  'noun:incidents:lowercase': 'incidentes',
  'noun:incidents:lowercase:singular': 'incidente',
  'noun:help-support': 'Ajuda e suporte',
  'noun:senderAddress2': 'Origem',
  'noun:recipientAddress2': 'Destino',
  'noun:destinAddress2': 'Destino',
  'noun:refundValue': 'Reembolso',
  'noun:shippingTypeCode': 'Tipo de produto',
  'noun:shipment': 'Envio',
  'noun:shipments': 'Envios',
  'noun:sender': 'Remetente',
  'shipping-detail:sender-data': 'Dados do remetente:',
  'noun:receptor': 'Destinatário',
  'noun:inventory': 'Inventário do conteúdo',
  'noun:normative': 'Normativa Aduaneira declarada',
  'noun:normative-1': 'Declaração de Dupla Utilização',
  'noun:normative-2': 'Declaração CITES',
  'noun:normative-3': 'Exportação Permanente',
  'noun:normative-4': 'Declaração de Resíduos',
  'noun:document': 'Documento {number}: {serial}',
  'noun:additional-documentation': 'Documentação adicional aduaneira',
  'noun:shipments:lowercase': 'envios',
  'noun:shipments:lowercase:singular': 'envio',
  'noun:shipment-destiny': 'Envio / Destino',
  'noun:last-status': 'Último estado',
  'noun:resume': 'Resumo',
  'noun:allocation-center': 'Centro de imputação',
  'noun:postal-address': 'Morada postal',
  'noun:incorrect-address': 'Morada incorreta',
  'noun:resolve-incident': 'Resolver incidente',
  'noun:add-address': 'Adicionar morada',
  'noun:name': 'Nome',
  'noun:phonePrefix': 'Indicativo (telf.)',
  'noun:name-company': 'Nome / Empresa',
  'noun:address': 'Morada',
  'noun:contact-client-code': 'Código de cliente habitual',
  'noun:recipient-contact': 'Contacto destinatário',
  'noun:customs-info-title': 'Informação para alfândega (opcional)',
  'noun:customs-type-label': 'Empresa / Particular',
  'noun:select-placeholder': 'Selecione uma opção',
  'noun:customs-name-company': 'Nome da empresa',
  'noun:customs-name-individual': 'Nome para documentação',
  'noun:customs-document-company': 'CIF / NIF',
  'noun:customs-document-individual': 'DNI / NIE',
  'noun:customs-name-placeholder-company': 'Indique o nome da empresa',
  'noun:customs-name-placeholder-individual': 'Indique o nome para a fatura',
  'noun:customs-document-placeholder-company':
    'Introduza o CIF ou NIF da empresa',
  'noun:customs-document-placeholder-individual':
    'Introduza o DNI ou NIE do particular',
  'noun:country': 'País',
  'noun:country-code': 'Código país',
  'noun:destination-country': 'País de destino',
  'noun:postal-code': 'Código postal',
  'noun:problem': 'Problema',
  'noun:request': 'Pedido',
  'noun:question': 'Pergunta',
  'noun:from-source': 'Por origem',
  'noun:from-destin': 'Por destino',
  'noun:complaints-and-claims': 'Reclamações e queixas',
  'noun:suggestions': 'Sugestões',
  'noun:deliveryDate': 'Data de entrega',
  'noun:schedule': 'Horário',
  'noun:commodityType': 'Tipo de mercadoria',

  'noun:city': 'Localidade',
  'noun:province': 'Distrito',
  'noun:phone': 'Telefone',
  'noun:mobile-phone': 'Telemóvel',
  'noun:mobile-phone-optional': 'Telemóvel (Opcional)',
  'noun:contact-phone': 'Telefone de contacto',
  'noun:email': 'Endereço de email',
  'noun:contact-email': 'Email de contacto',
  'noun:floor': 'Andar',
  'noun:stair': 'Escada',
  'noun:letter': 'Letra',
  'noun:pick-up-date': 'Data de recolha',
  'noun:timetable': 'Horário',
  'noun:time-slot': 'Intervalo horário',
  'noun:comments': 'Observações',
  'noun:additional-services': 'Serviços adicionais',
  'noun:customs': 'Alfândega',
  'noun:additional-services-title':
    'Existe algum serviço adicional que queira adicionar?',
  'noun:additional-services-description':
    'Disponibilizamos os seguintes serviços adicionais. Selecione os que necessita:',
  'noun:pudos-additional-services-title':
    'Lamentamos, mas não é possível adicionar serviços adicionais na entrega num Ponto CTT Express',
  'noun:additional-services-empty': 'Não contratou qualquer serviço adicional',
  'noun:weight': 'Peso',
  'noun:length': 'Comprimento',
  'noun:width': 'Largura',
  'noun:height': 'Altura',
  'noun:yes': 'Sim',
  'noun:no': 'Não',
  'noun:type-of': 'Tipo de {type}',
  'noun:service-type': 'Tipo de serviço',
  'noun:clientReference': 'Referência',
  'noun:number-of-packages': 'Volumes',
  'noun:total-weight-kgs': 'Peso total em kg',
  'noun:last-update': 'Última atualização',
  'noun:declared-value': 'Valor declarado',
  'noun:return-value': 'Quantidade de volumes',
  'noun:refund': 'Reembolso',
  'noun:refund-amount': 'Valor do reembolso',
  'noun:refund-description':
    'Este serviço permite gerir a cobrança do valor da mercadoria no destino. Indique o valor que o destinatário deve pagar no momento da entrega (até ao máximo de {formattedAmount} €). Serviço exclusivo para envios com destino a Espanha ou Portugal.',
  'noun:insurance-merchandise': 'Valor da mercadoria segurada',
  'noun:additional-coverage': 'Cobertura adicional',
  'noun:additional-coverage-description-national':
    'Cobertura por perda ou roubo do valor do conteúdo declarado (até ao máximo de {formattedAmount} €). Indique o valor declarado da sua mercadoria. O custo desta cobertura corresponde a 1,50% do valor declarado (mínimo de 2 €).',
  'noun:additional-coverage-description-international':
    'Cobertura por perda ou roubo do valor do conteúdo declarado (até ao máximo de {formattedAmount} €). Indique o valor declarado da sua mercadoria. O custo desta cobertura corresponde a 1% do valor declarado (mínimo de 10 €).',
  'noun:insurance-merchandise-description':
    'Indique o valor aproximado pelo qual a sua mercadoria se encontra segurada.',
  'noun:additional-return':
    'Este serviço permite a entrega da sua mercadoria ao destinatário e, em simultâneo, possibilita que o destinatário nos entregue, nesse mesmo momento, outra mercadoria para devolução.',
  'noun:additional-slip-scan':
    'Serviço de digitalização da guia do cliente, assinada pelo destinatário no momento da entrega.',
  'noun:insurance-value': 'Valor do seguro',
  'noun:origin-data': 'Dados de origem',
  'noun:destination-data': 'Dados de destino',
  'noun:name-surname': 'Nome e apelidos',
  'noun:description': 'Descrição',
  'noun:date': 'Data',
  'noun:selected-timetable': 'Horário preferido',
  'noun:ask-about': 'Perguntamos por',
  'noun:shipment-detail': 'Detalhe do envio',
  'noun:commercial-bill': 'Dados da fatura comercial',
  'noun:contracted-service': 'Serviço contratado',
  'noun:reference': 'Referência',
  'noun:total-packages': 'Volumes',
  'noun:total-packages-plural': '{count, plural, one {Volume} other {Volumes}}',
  'noun:CP-sender': 'CP Remetente',
  'noun:CP-destination': 'CP Destinatário',
  'noun:CTT-point': 'Ponto CTT Express',

  'noun:return': 'Retorno',
  'noun:return-shipment-number': 'N.º do envio devolvido',
  'noun:declared-price': 'Valor declarado',
  'noun:dni-verification': 'Verificação de DNI',
  'noun:reference2': 'Referência 2',
  'noun:enter-size-and-aprox-weight': 'Indique as medidas e o peso aproximado',
  'noun:appraisal-weight': 'Peso de avaliação',
  'noun:reported weight': 'Peso informado',
  'noun:insured-value': 'Valor seguro',
  'noun:id-verification': 'Verificação de DNI',
  'noun:department': 'Departamento',
  'noun:file_name': 'Nome do ficheiro',
  'noun:upload_datetime': 'Data de carregamento',
  'noun:upload_hour': 'Hora',
  'noun:success_lines': 'Envios corretos',
  'noun:error_lines': 'Envios incorretos',
  'noun:success_lines_agenda': 'Contactos carregados',
  'noun:error_lines_agenda': 'Contactos não carregados',
  'noun:shippingCode': 'Nº do envio',
  'noun:shippingDate': 'Data',
  'noun:shippingStatusCode': 'Estado',
  'noun:incidentDescription': 'Descrição do incidente',
  'noun:clientCenterCode': 'Relatórios',

  'noun:reports': 'Documento',
  'noun:report': 'Subscrição',
  'noun:download': 'Tipo',
  'noun:subscription': 'Definições',
  'noun:type': 'Destinatário',
  'noun:settings': 'Filtros',

  'noun:recipientName': 'Voltar aos relatórios',
  'noun:filters': 'Estados',
  'noun:reportConfig': 'Incidentes geríveis',
  'noun:reportList': 'Lida',
  'noun:state-filters': 'Estado',

  'noun:read': 'Lida',
  'noun:all': 'Todos',
  'noun:from': 'De',
  'noun:to': 'Até',
  'noun:by-incident-type': 'Incidentes geríveis',
  'noun:by-last-status': 'Por último estado',
  'noun:search-by-date': 'Pesquisar por data',
  'noun:any-date': 'Qualquer data',
  'noun:last-month': 'Último mês',
  'noun:last-quarter': 'Último trimestre',
  'noun:want-search-by-range': 'Quero pesquisar por intervalo',
  'noun:date-first-reading': 'Data de registo',
  'noun:expected-delivery-date': 'Data prevista de entrega',
  'noun:tomorrow': 'Amanhã',
  'noun:not-defined': 'Não definida',
  'noun:edit': 'Editar',
  'noun:cancel': 'Anular',
  'noun:my-contracts': 'Os meus contratos',
  'noun:billing': 'Faturação',
  'noun:invoices': 'Faturas',
  'noun:print-settings': 'Definições de impressão',
  'noun:user-zone': 'Área de utilizador',
  'noun:account': 'A minha conta',
  'noun:go-to-print-settings': 'Ir para as definições de impressão',
  'noun:invoice-number': 'N.º de fatura',
  'noun:client-center-code': 'Código do centro do cliente',
  'noun:amount-in-€': 'Valor em €',
  'noun:amount': 'Valor',
  'noun:base-amount': 'Valor base',
  'noun:weight-extra-amount': 'Débito por excesso de peso/medidas',
  'noun:city-origin': 'Localidade de origem',
  'noun:city-destiny': 'Localidade de destino',
  'noun:last-status-date': 'Data do último estado',
  'noun:article:country': 'o país',
  'noun:article:name': 'o nome do estabelecimento',
  'noun:article:postalCode': 'o código postal',
  'noun:article:city': 'a cidade',
  'noun:article:route': 'a rua',
  'noun:article:streetNumber': 'o número da rua',
  'noun:and': 'e',
  'noun:elements-per-page': 'Elementos por página',
  'noun:shipments-per-page': 'Envios por página',
  'noun:contacts-per-page': 'Contactos por página',
  'noun:files-per-page': 'Ficheiros por página',
  'noun:contacts': 'Contactos',
  'noun:date-and-time': 'Data e hora',
  'noun:shipping-item': 'Volume',
  'noun:-appraisal-weight': 'Peso total aproximado',
  'noun:sure-logout': 'Tem a certeza de que pretende terminar sessão?',
  'noun:all-your-shippings': 'Todos os seus envios',
  'noun:my-agenda': 'A minha agenda',
  'noun:imported-register': 'Registo de importação',

  'noun:under-construction': 'Em construção!',
  'noun:under-construction-explanation':
    'Estamos a trabalhar para que, em breve, possa ver e descarregar as suas faturas aqui.',
  'noun:shipping-number': 'Número de envio',
  'noun:contact-data': 'Dados de contacto',
  'noun:subject': 'Assunto',
  'noun:CLIENTWEB_CI_4': 'Pedido de envio',
  'noun:CLIENTWEB_CI_5': 'Seguir',
  'noun:CLIENTWEB_CI_6': 'Gestão de incidentes',
  'noun:CLIENTWEB_CI_7': 'Agenda',
  'noun:CLIENTWEB_CI_8': 'Impressão',
  'noun:CLIENTWEB_CI_9': 'Configuração (Centros, Faturação, Dados de moradas)',
  'noun:CLIENTWEB_OTROS': 'Outro',
  'noun:CLIENTWEB_IN_1': 'Módulos de e‑commerce',
  'noun:CLIENTWEB_IN_2': 'Mapper',
  'noun:CLIENTWEB_IN_3': 'Integração: ApiRest, WebService ou Ficheiros',
  'noun:CLIENTWEB_ATC_1': 'Incidentes de envios',
  'noun:CLIENTWEB_ATC_2': 'Sugestões',
  'noun:CLIENTWEB_ATC_3': 'Queixas',
  'noun:CLIENTWEB_SALES_3': 'Alteração da morada operacional do contrato',
  'noun:CLIENTWEB_SALES_4': 'Tarifas e custos',
  'noun:CLIENTWEB_SALES_5': 'Atualização de dados de contacto',
  'noun:CLIENTWEB_SALES_6': 'Contacto ou visita comercial',
  'noun:CLIENTWEB_BILL_2': 'Envios à cobrança (contra reembolso)',
  'noun:CLIENTWEB_BILL_3': 'Faturas',
  'noun:CLIENTWEB_BILL_4': 'Notas de crédito',
  'noun:CLIENTWEB_BILL_5': 'Conta bancária',
  'noun:other': 'Outros',
  'noun:manifest': 'Manifesto',
  'noun:download-shippings': 'Filtros avançados e descarga',
  'noun:generation-manifest-date': 'Data:',
  'noun:generation-manifest-shipments': 'Manifesto de envios',
  'noun:generation-manifest-packages': 'Total de volumes:',
  'noun:generation-manifest-shippings': 'Total de envios:',
  'noun:generation-manifest-weight': 'Peso total informado:',
  'noun:generation-manifest-return': 'Total de reembolsos:',
  'noun:recipient-date': 'Dados do destinatário',
  'noun:returns': 'Devoluções',
  'noun:activate-return': 'Solicitar devolução',
  'noun:return-number': 'N.º do envio da devolução:',
  'noun:unscheduled-pickups': 'Recolhas sem agendamento',
  'noun:unscheduled': 'Recolhas sem agendamento',
  'noun:maintenance': 'Manutenção',
  'noun:sorry-for-inconveniences': 'Pedimos desculpa pelo incómodo',
  'noun:shippingWeight': 'Peso informado',
  'noun:spanish': 'Espanhol',
  'noun:english': 'Inglês',
  'noun:volumetric-weight': 'Peso volumétrico informado',

  // Fields
  'field:optional': '{field} <span> Opcional</span>',
  'field:money-suffix': '€',
  'field:packages-suffix':
    '{packages, plural, one {1 volume} other {{packages} volumes}}',
  'field:first-pickup-option':
    '{minDate, date, full} das {minDate, time, short} às {maxDate, time, short}',

  // Generic messages
  'message:saving': 'A guardar…',
  'message:loading': 'A carregar…',
  'message:asap': 'Recolha proposta',
  'message:fixedPickup': 'A minha recolha fixa',
  'message:choose-pickup-with-fixed-pickup':
    'Esta recolha será adicional à sua recolha fixa.',
  'message:time-slot':
    'Se pretende que recolhamos o seu envio na data e no intervalo horário selecionados, envie o pedido durante {minutes, plural, =0 {o próximo minuto} one {o próximo minuto} other {os próximos # minutos}}.',
  'message:no-results': 'Não existem envios para mostrar',
  'message:no-results:shippings':
    'Não existe nenhum pedido com esta referência. Verifique ou tente outro número.',
  'message:no-results:returns':
    'Não existe nenhum pedido com esta referência. Verifique ou tente outro número.',
  'message:no-results:incidents':
    'Não existe nenhum pedido com esta referência. Verifique ou tente outro número.',
  'message:no-results:unscheduled':
    'Não existem envios sem agendamento para a pesquisa efetuada',
  'message:form-errors-destin:title': 'Desta forma vai substituir o destino',
  'message:form-errors-destin:detail':
    'Introduziu dados sobre o seu envio, mas se continuar, essa informação será perdida.',
  'message:form-errors:title': 'Existem erros no formulário',
  'message:form-errors:detail':
    'Para avançar para outra secção, deve primeiro corrigi‑los ou descartar as alterações efetuadas.',
  'message:save-changes:title': 'Não quer guardar as alterações?',
  'message:save-changes:detail':
    'Se quiser continuar e não as perder, deve guardá‑las agora.',
  'message:abandon-process:title': 'Vai sair do processo de pedido',
  'message:abandon-process:detail':
    'Se sair agora, todos os dados serão perdidos e terá de iniciar um novo processo.',
  'message:successful-shipment': 'O seu envio foi registado com sucesso!',
  'message:outside-origin':
    'Lembre‑se de que, se esta origem não estiver dentro da sua zona habitual, as condições do serviço poderão ser alteradas.',
  'message:outside-destination-km-10h':
    'Algumas localidades implicam um suplemento por quilometragem no serviço das 10h.',
  'message:outside-destination-km-10h-mi':
    'Ver localidades com suplemento de quilometragem',
  'message:choose-day': 'Primeiro, escolha um dia para a recolha.',
  'message:choose-day-hour': 'Escolha o dia e o horário para a sua recolha',
  'message:choose-timeslot': 'Por fim, escolha um intervalo horário.',
  'message:choose-schedule': 'De seguida, escolha um horário.',
  'message:you-are-going-to-cancel-shipment': 'Vai anular estes envios',
  'message:if-you-cancel-this-shipment-you-cant-recovery':
    'Depois de anular estes pedidos, não será possível recuperá‑los.',
  'message:duplicate-shipment-title': 'Duplicar este envio?',
  'message:duplicate-shipment-description':
    'Vamos criar um novo envio com as mesmas características, peso e medidas do original. O envio original não será alterado.',
  'message:most-sustainable-option': 'Opção mais sustentável',
  'message:search-by-street-zone-or-postal-code':
    'Procure aqui o código postal ou a morada e selecione um Ponto CTT Express',
  'message:click-on-confirm-to-continue':
    'Clique em “Confirmar” para continuar o processo.',
  'message:pickup-point-contact-data':
    'Assim que a mercadoria for depositada no Ponto CTT Express, iremos avisar o destinatário para proceder à recolha.',
  'message:unscheduled-date-subtitle':
    'Lembre‑se de que pode programar esta recolha no detalhe do envio e na secção Seguir envio.',
  'message:preparing-download': 'A preparar descarga',

  'pickupPoint:title': 'Recolha direta num Ponto CTT Express',
  'pickupPoint:subtitle': 'A origem será selecionada pelo remetente',

  // Weekdays
  'weekday:1': 'Segunda‑feira',
  'weekday:2': 'Terça‑feira',
  'weekday:3': 'Quarta‑feira',
  'weekday:4': 'Quinta‑feira',
  'weekday:5': 'Sexta‑feira',
  'weekday:6': 'Sábado',
  'weekday:7': 'Domingo',

  // Generic errors
  'error:404:title': 'Não foi possível encontrar a página que procura',
  'error:404:text':
    'Recomendamos que volte à página inicial ou utilize as opções do menu enquanto resolvemos o problema.',
  'error:server:title': 'Parece que ocorreu um problema',
  'error:server:text':
    'Recomendamos que volte à página inicial ou utilize as opções do menu enquanto resolvemos o problema.',
  'error:connection:title': 'Parece existir um problema de ligação',
  'error:connection:text':
    'É possível que não tenha ligação à Internet ou que esta esteja a falhar. Recomendamos que:',
  'error:internal:title': 'Parece que ocorreu um problema',
  'error:internal:text':
    'Não é possível apresentar a página que procura. Poderá existir um problema de ligação ao servidor.',
  'error:contact-with-us':
    'Se o problema persistir, <Link>contacte‑nos</Link>.',
  'error:network':
    'Parece existir um problema de ligação. Verifique a sua ligação à Internet ou tente novamente mais tarde.',
  'error:limit-exceeded':
    'Ultrapassou o número máximo de tentativas. Por favor, tente novamente mais tarde.',
  'error:code-mismatch': 'Código inválido. Por favor, tente novamente.',
  'error:general':
    'Ocorreu um erro durante o pedido. Por favor, tente novamente mais tarde.',
  'error:cancel-shipment':
    'Ocorreu um erro ao anular os envios. Por favor, tente novamente.',
  'error:duplicate-shipment':
    'Ocorreu um erro ao duplicar o envio. Por favor, tente novamente.',

  // Form errors
  'error:form:request-generic': 'Ocorreu um erro ao efetuar o pedido',
  'error:form:debug': 'Erro forçado para fins de teste',
  'error:form:step':
    'Ocorreu um erro neste passo. Por favor, altere os dados para continuar.',
  'error:form:search-not-possible':
    'Não foi possível realizar a pesquisa. Por favor, tente novamente.',
  'error:form:search-not-possible-verify-postal-code':
    'Não foi possível identificar o código postal para esta morada. Por favor, seja mais preciso ao indicar a morada.',
  'error:form:customs':
    'Existem campos obrigatórios por preencher. Verifique antes de continuar.',

  // Form field errors
  'error:field:required': 'Este campo é obrigatório.',
  'error:field:conditions-required':
    'Por favor, aceite os campos assinalados a vermelho:',
  'error:field:phone:required': 'O telefone é obrigatório.',
  'error:field:postal-code:required': 'O código postal é obrigatório.',
  'error:field:customs-name:required': 'Este campo é obrigatório.',
  'error:field:customs-document:required': 'Este campo é obrigatório.',
  'error:field:streetNumber:required': 'O número da porta é obrigatório.',
  'error:field:route:required': 'A rua é obrigatória.',
  'error:field:min-length-required': 'O comprimento mínimo é de 6 caracteres.',
  'error:field:min-string-length':
    'O comprimento mínimo é de {min} caracteres.',
  'error:field:max-string-length':
    'O comprimento máximo é de {max} caracteres.',
  'error:field:min-array-length': 'Deve introduzir pelo menos um elemento.',
  'error:field:min-date': 'A data mínima é {min, date, ::yyyyMMdd}.',
  'error:field:min-number': 'O valor mínimo é {min, number}.',
  'error:field:max-number': 'O valor máximo é {max, number}.',
  'error:field:min-monetary-amount': 'O valor mínimo é {formattedAmount} €.',
  'error:field:max-monetary-amount': 'O valor máximo é {formattedAmount} €.',
  'error:field:no-zero': 'O valor não pode ser 0 €.',
  'error:field:email': 'Introduza um endereço de email válido.',
  'error:field:password': 'Deve introduzir uma palavra‑passe válida.',
  'error:field:invalid': 'O valor não é válido.',
  'error:field:cp-format':
    'O código postal é inválido para o país selecionado.',
  'error:field:package-row:empty-fields':
    'Preencha todos os campos obrigatórios.',

  'error:field:not-found-results-with-postal-code':
    'Não foram encontrados resultados para este código postal. Verifique se está correto.',
  'error:shipment-number:length': 'O código de envio deve ter 22 dígitos.',
  'error:shipment-number:not-found': 'O código de envio não existe.',
  'error:origin-address:invalid-origin':
    'Não é possível registar uma recolha numa morada fora de Espanha ou Portugal. Escolha outra morada para continuar.',
  'error:field:package-row:weight-exceeded':
    'O peso por volume introduzido excede o máximo permitido de {value} kg.',
  'error:field:package-row:measure-exceeded':
    'A altura, largura ou comprimento excede a medida máxima permitida de {value} cm.',
  'error:field:package-row:height-exceeded':
    'A altura excede a medida máxima permitida de {value} cm.',
  'error:field:package-row:width-exceeded':
    'A largura excede a medida máxima permitida de {value} cm.',
  'error:field:package-row:length-exceeded':
    'O comprimento excede a medida máxima permitida de {value} cm.',
  'error:field:package-row:measures-sum-exceeded-pudos':
    'A soma da altura, largura e comprimento não pode ser superior a {value} cm.',
  'error:field:package-row:measures-sum-exceeded':
    'Esta origem ou destino não admite o peso volumétrico informado.',
  'error:field:package-row:weight-minimum':
    'O peso mínimo por volume deve ser superior a 0 kg.',
  'error:field:package-row:width-minimum':
    'O comprimento mínimo por volume deve ser superior a 0 cm.',
  'error:field:package-row:length-minimum':
    'A largura mínima por volume deve ser superior a 0 cm.',
  'error:field:package-row:height-minimum':
    'A altura mínima por volume deve ser superior a 0 cm.',
  'error:field:max-files': 'O número máximo de ficheiros é {maxFiles}.',
  'error:customs:min-value': 'A quantidade mínima é 1.',
  'error:customs:max-value': 'A quantidade máxima é 9 999 999.',
  'error:customs-description:max-value':
    'O comprimento não pode exceder 70 caracteres.',
  'error:albaran-not-found':
    'O ficheiro não está disponível neste momento. <p>Por favor, tente novamente mais tarde.</p>',
  'error:document-not-available': 'Documento não está disponível.',

  // Frontpage
  'frontpage:placeholder': 'Placeholder da página raiz',
  'frontpage:user':
    'Sessão iniciada como o utilizador {user} a {date, date, full} às {date, time, full}',

  // Login
  'login:title': 'Iniciar sessão no CTT Express',
  'login:title-mobile': 'Entrar na sua área pessoal',
  'login:error:form:user-not-found':
    'O email e/ou a palavra-passe não estão corretos.',
  'login:error:form:user-requires-new-password':
    'Não foi possível iniciar sessão com uma palavra-passe temporária. Contacte o administrador para alterar a sua palavra-passe.',
  'login:remember-password': 'Não me lembro da minha palavra-passe',
  'login:recover-password': 'Recuperar a minha palavra-passe',
  'login:create-account-explanation':
    'Se tem um negócio e ainda não tem conta no CTT Express, deixe-nos os seus dados <strong><link>aqui</link></strong> e nós ligamos. Sem compromisso!',

  // Send Code
  'request-password-reset:explanation':
    'Indique o email de registo no CTT Express para lhe enviarmos um código de acesso:',
  'request-password-reset:warning:check-spam':
    'Se não vir o nosso email, verifique a pasta de spam',

  // Reset Password
  'reset-password:enter-code-and-choose-password':
    'Introduza aqui o código que lhe enviámos e escolha uma palavra-passe:',
  'reset-password:email-not-received-send-again':
    'Não recebi o email, enviem novamente',
  'reset-password:warning:validate-password':
    'A sua palavra-passe deve ter, pelo menos, 8 caracteres, incluindo uma maiúscula e um número.',

  // Shipping Send Form
  'shipping-send-form:title': 'Quero solicitar um envio',
  'shipping-send-form:new-address:phone-length-error': 'Telefone incorreto',
  'shipping-send-form:address:no-phone-error':
    'A morada selecionada não está completa. É necessário adicionar o número de telefone para continuar.',
  'shipping-send-form:address:no-phone-email-error-center':
    'O centro escolhido tem informação incompleta. Por favor, contacte o seu comercial para completar os dados e garantir a entrega.',
  'shipping-send-form:new-address:phone-min-length-error':
    'Telefone incorreto. Deve ter, no mínimo, 6 caracteres.',
  'shipping-send-form:new-address:phone-max-length-error':
    'Telefone incorreto. Deve ter, no máximo, 15 caracteres.',
  'shipping-send-form:new-address:phone-format-error': 'Formato incorreto',
  'shipping-send-form:new-address:phone-format-or-length-error':
    'Formato ou comprimento do telefone incorreto',
  'shipping-send-form:new-address:dni-format-error': 'Formato incorreto',
  'shipping-send-form:new-address:phone-digits-error':
    'O número deve ter 9 dígitos',
  'shipping-send-form:new-address:phone-initial-number-error':
    'Um número de telemóvel não pode começar por 9',
  'shipping-send-form:new-address:placeholder':
    'Procure a sua morada e os campos serão preenchidos automaticamente',
  'shipping-send-form:new-address-agenda:placeholder':
    'Procure a sua morada e os campos serão preenchidos automaticamente',
  'shipping-send-form:origin': 'Recolher na origem:',
  'shipping-send-form:summary:pickup':
    '{weekDay}, {minDate, date, short} das {minDate, time, short} às {maxDate, time, short}',
  'shipping-send-form:pickup-date':
    'Passaremos para recolher no dia {minDate, date, ::ddMMyyyy} das {minDate, time, short} às {maxDate, time, short}',
  'shipping-send-form:fixed-pickup-date':
    'Passaremos para recolher no dia {fromDate, date, ::ddMMyyyy} das {fromDate, time, short} às {toDate, time, short}',
  'shipping-send-form:origin:timetable:morning':
    'Manhã ({minDate, time, short} às {maxDate, time, short})',
  'shipping-send-form:origin:timetable:afternoon':
    'Tarde ({minDate, time, short} às {maxDate, time, short})',
  'shipping-send-form:origin:new-address:address-finder': 'Pesquisa de moradas',
  'shipping-send-form:origin:new-address:address': 'Morada',
  'shipping-send-form:origin:new-address:postal-code': 'Código postal',
  'shipping-send-form:origin:new-address:postal-code-placeholder': '1234…',
  'shipping-send-form:origin:new-address:postal-code-es-placeholder': '12345',
  'shipping-send-form:origin:new-address:postal-code-pt-placeholder': '1234567',
  'shipping-send-form:origin:new-address:province': 'Distrito',
  'shipping-send-form:origin:new-address:city': 'Cidade',
  'shipping-send-form:origin:new-address:locality': 'Localidade',
  'shipping-send-form:origin:new-address:comments-label':
    'Exemplo: Estrada Puxeiros, km 6, Armazém 1',
  'shipping-send-form:origin:pickup:choose-schedule': 'Escolha o horário',
  'shipping-send-form:origin:pickup:asap-requirements':
    'Para calcular a data de recolha mais rápida, precisamos que nos indique um código postal',
  'shipping-send-form:origin:pickup:choose-requirements':
    'Antes de lhe apresentar as datas disponíveis, precisamos que nos indique um código postal',
  'shipping-send-form:origin:timetable:anytime': 'Em qualquer hora do dia',
  'shipping-send-form:origin:timetable:select-timeslot':
    'Escolher intervalo horário',
  'shipping-send-form:origin-mobile': 'Recolher na origem:',
  'shipping-send-form:destination-mobile': 'Entregar no destino:',
  'shipping-send-form:title:center': 'Escolha o seu centro de custos',
  'shipping-send-form:title:origin-address': 'Onde deve ser feita a recolha?',
  'shipping-send-form:label:existing-address': 'Numa das minhas moradas',
  'shipping-send-form:label:contract-address': 'Morada do contrato',
  'shipping-send-form:label:other-address': 'Noutra morada',
  'shipping-send-form:label:new-address': 'Numa nova morada',
  'shipping-send-form:label:pick-up-point': 'Num Ponto CTT Express',
  'shipping-send-form:label:pick-up-point-collect':
    'Num Ponto Pick&Drop',
  'shipping-send-form:label:tooltip-autofill-postal-code':
    'Este campo é preenchido automaticamente ao introduzir o código postal.',
  'shipping-send-form:helper-text:several-localities-associate-with-postal-code':
    'Encontrámos várias localidades associadas ao código postal introduzido. Por favor, selecione a localidade correta.',
  'shipping-send-form:helper-text:not-found-localities-input-manually':
    'Não encontrámos moradas associadas ao código postal introduzido. Por favor, preencha o campo manualmente.',
  'shipping-send-form:helper-text:not-found-province-input-manually':
    'Não encontrámos distritos associados ao código postal introduzido. Por favor, preencha o campo manualmente.',
  'shipping-send-form:contact-details': 'Perguntamos por quem?',
  'shipping-send-form:title:pick-up-date':
    'Quando pretende que passemos para recolher?',
  'shipping-send-form:title:additional-comments':
    'Há algo que o nosso distribuidor deva saber?',
  'shipping-send-form:placeholder:additional-comments':
    'Estrada, Urbanização, Bloco, etc.',
  'shipping-send-form:label:additional-comments':
    'Outros dados relevantes da morada',
  'shipping-send-form:action:back-from': 'Voltar à origem',
  'shipping-send-form:action:back-to': 'Voltar ao destino',
  'shipping-send-form:action:back-shipment': 'Voltar ao envio',
  'shipping-send-form:action:back-services': 'Voltar aos serviços adicionais',
  'shipping-send-form:action:back-customs': 'Voltar à alfândega',
  'shipping-send-form:action:back-summary': 'Voltar ao resumo',
  'shipping-send-form:action:back-init': 'Voltar ao início',
  'shipping-send-form:action:confirm-address': 'Confirmar morada',
  'shipping-send-form:action:confirm-data-destination':
    'Confirmar dados do destino',
  'shipping-send-form:action:confirm-data-origin': 'Confirmar dados da origem',
  'shipping-send-form:action:cancel-my-request': 'Cancelar o meu pedido',
  'shipping-send-form:action:process-shipment': 'Processar este envio',
  'shipping-send-form:action:confirm-cancellation': 'Sim, quero cancelar',
  'shipping-send-form:snackbar-address-saved': 'Morada guardada na sua agenda',
  'shipping-send-form:alert-address-saved':
    'Esta morada foi guardada na sua agenda.',
  'shipping-send-form:alert-address-saved-error':
    'Não foi possível guardar a morada na sua agenda.',
  'shipping-send-form:try-again': 'Tentar novamente',
  'shipping-send-form:time-slot-option':
    'das {minDate, time, short} às {maxDate, time, short}',
  'shipping-send-form:error:time-slot':
    'A opção selecionada já não está disponível',
  'shipping-send-form:origin:postal-code:invalid-format':
    'Formato de código postal incorreto',

  'shipping-send-form:origin:no-available-hours':
    'Não existem datas disponíveis',
  'shipping-send-form:origin:select-postal-code':
    'Primeiro, indique-nos um código postal',
  'shipping-send-form:origin:pickup-not-available':
    'Ocorreu um problema ao obter a data de recolha mais rápida',
  'shipping-send-form:origin:not-available-dates':
    'Neste momento, não é possível apresentar uma data de recolha. Tente mais tarde e, se o erro persistir, contacte a equipa de Suporte informático.',
  'shipping-send-form:origin:select-poblation':
    'Não aparecem datas disponíveis porque não indicou um código postal',
  'shipping-send-form:title:destination-address': 'Indique a morada de destino',
  'shipping-send-form:agenda': 'Agenda',
  'shipping-send-form:address-edition': 'Editar morada da agenda',
  'shipping-send-form:address-edition:success':
    'A morada foi alterada com sucesso',
  'shipping-send-form:address:no-address':
    'Ainda não tem nenhuma morada de destino na sua agenda. Indique uma nova morada para continuar.',
  'shipping-send-form:address-edition:return': 'Voltar à pesquisa de moradas',
  'shipping-send-form:shipment:service-type': 'Escolha um tipo de serviço',
  'shipping-send-form:shipment:custom': 'Direitos aduaneiros',
  'shipping-send-form:shipment:custom-charge':
    'Selecione quem ficará responsável pelos direitos aduaneiros:',
  'shipping-send-form:shipment:service-type:info':
    'Mostramos apenas os que melhor se adequam ao seu pedido',
  'shipping-send-form:shipment:reference-number':
    'Quer adicionar o seu próprio n.º de referência?',
  'shipping-send-form:shipment:commodity-type': 'Tipo de mercadoria',
  'shipping-send-form:shipment:select-commodity-type':
    'Selecione o tipo de mercadoria:',
  'shipping-send-form:shipment:packages': 'Indique as medidas e o peso',
  'shipping-send-form:shipment:packages:content':
    'Quanto mais preciso for com o peso do envio, melhor serviço poderemos oferecer.',
  'shipping-send-form:shipment:information': 'Informação sobre o seu envio',
  'shipping-send-form:shipment:need-information':
    'Quanto mais preciso for com o peso do envio, melhor serviço poderemos oferecer:',
  'shipping-send-form:shipment:fill-packages':
    'Preencha a informação dos volumes do seu envio para ver os serviços que melhor se adequam.',
  'shipping-send-form:shipment:wrong-sizes-or-weight':
    'Não existem serviços para as medidas e o peso indicados.',
  'shipping-send-form:shipment:single-item-warning':
    'Este serviço só permite envios de um único volume.',
  'shipping-send-form:shipment:purchase-sale': 'É uma compra/venda',
  'shipping-send-form:shipment:between-individuals':
    'É um envio normal entre particulares',
  'shipping-send-form:shipment:documents': 'Documentos',
  'shipping-send-form:shipment:merchandise': 'Mercadoria',
  'shipping-send-form:shipment:content-type':
    'Que tipo de conteúdo pretende enviar?',
  'shipping-send-form:shipment:fill-next-information':
    'Indique a informação seguinte',
  'shipping-send-form:shipment:address-change-detected':
    'Alteração de código postal detetada',
  'shipping-send-form:shipment:origin-address-changed':
    'Alterou a origem do seu envio. Deve voltar a preencher os volumes e selecionar uma nova tarifa.',
  'shipping-send-form:shipment:destin-address-changed':
    'Alterou o destino do seu envio. Deve voltar a preencher os volumes e selecionar uma nova tarifa.',
  'shipping-send-form:shipment:merchandise-info':
    'Quanto mais preciso for com o peso e as medidas do envio, melhor previsão de avaliação poderemos apresentar.',
  'shipping-send-form:shipment:merchandise-label': 'Tipo de mercadoria',
  'shipping-send-form:shipment:merchandise-placeholder':
    'Eletrónica, baterias, roupa, álcool…',
  'shipping-send-form:shipment:document-type': 'Tipo de documento',
  'shipping-send-form:shipment:document-description': 'Descrição do documento',
  'shipping-send-form:shipment:document-type:personal':
    'Documento pessoal (por exemplo, uma carta)',
  'shipping-send-form:shipment:document-type:internal':
    'Documento interno da empresa (por exemplo, um memorando)',
  'shipping-send-form:shipment:document-type:commercial':
    'Documento comercial (por exemplo, um contrato)',
  'shipping-send-form:shipment:document-type:other': 'Outros',
  'shipping-send-form:shipment:custom-value': 'Valor para a alfândega',
  'shipping-send-form:shipment:limitations':
    'Alguns tipos de envio têm limitações. Antes de indicar estes dados, precisamos de saber que tipo de serviço necessita.',
  'shipping-send-form:shipment:own-reference-number':
    'Se adicionar o seu próprio número de referência, será mais fácil seguir o envio',
  'shipping-send:success:title': 'Transmitimos o seu pedido',
  'shipping-send:success:description':
    'Não se preocupe, não precisa de anotar nada. Já tem uma cópia no seu email',
  'shipping-send:cancel:title': 'Vai interromper o processo',
  'shipping-send:cancel:description':
    'Se cancelar o pedido, perderá todos os dados introduzidos',
  'shipping-send-form:shipment:destination-address-label': 'Morada de destino',
  'shipping-send-form:keep-in-mind': 'Tenha em conta que…',
  'shipping-send-form:sending-documents':
    'Indicou que o seu envio contém documentos, pelo que não necessita de documentação adicional para a alfândega.',
  'shipping-send-form:shipping-restrictions':
    'Lembre‑se de que, consoante o destino do envio, alguns tipos de mercadoria podem estar sujeitos a restrições ou condições especiais.',
  'shipping-send-form:customs-documentation-text':
    'O destino selecionado requer documentação aduaneira. De seguida, disponibilizamos um {invoiceModel}, uma {inventorySheet} e as {instructions} sobre como os preencher para facilitar o processo (se já dispuser de um modelo, pode utilizar o seu). Lembre‑se de anexar a documentação preenchida ao exterior da embalagem.',
  'shipping-send-form:invoice-model': 'modelo de documentação aduaneira',
  'shipping-send-form:instructions': 'instruções',
  'shipping-send-form:inventory-sheet': 'folha adicional de inventário',
  'shipping-send-form:download-fill-form':
    'Não se esqueça de descarregar e preencher o seguinte formulário para a alfândega.',
  'shipping-send-form:download-form': 'Descarregar formulário',
  'shipping-send-form:accurate-best-service':
    'Quanto mais preciso for, melhor serviço poderemos oferecer.',
  'shipping-send-message:schedule-may-change':
    'Os horários podem estar sujeitos a alterações por motivo de força maior.',
  'shipping-send-message:request-pickup-later':
    'Pode programar esta recolha no detalhe do envio e na secção Seguir envio.',
  'shipping-send-message:request-pickup-later-2':
    'Ficaremos a aguardar as suas indicações para que os nossos distribuidores passem para recolher este envio.',
  'shipping-send-form:customs:info':
    'A origem/destino selecionada implica alfândega, pelo que é importante preencher os dados seguintes para a criação da documentação necessária. Esta documentação será enviada diretamente às autoridades aduaneiras.',
  'shipping-send-form:customs:no-necessary': 'Documentação',
  'shipping-send-form:customs:no-necessary-body':
    'O envio que vai realizar não necessita de documentação.',
  'shipping-send-form:customs:title':
    'Documentação necessária para o seu envio',
  'shipping-send-form:customs:sender-info': '1. Informação do remetente',
  'shipping-send-form:customs:receptor-info': '2. Informação do destinatário',
  'shipping-send-form:customs:inventory-custom': '3. Inventário do conteúdo',
  'shipping-send-form:customs:additional': '4. Documentação adicional',
  'shipping-send-form:customs:legal-acceptance-title': 'ACEITAÇÃO LEGAL',
  'shipping-send-form:customs:legal-acceptance-body':
    'Certifique-se de ler e aceitar os termos legais:',
  'shipping-send-form:customs:authorized':
    'Li e declaro que a informação fornecida é correta e que a mercadoria enviada cumpre a',
  'shipping-send-form:customs:custom-normative': 'Normativa Aduaneira.',
  'shipping-send-form:customs:custom-normative-text-1':
    'Os envios realizados pela CTT Express são transportados em total cumprimento da lei e das regulamentações internacionais, pelo que é necessário aceitar a informação relativa aos regulamentos internacionais nas matérias seguintes, conforme exigido pelas autoridades aduaneiras.',
  'shipping-send-form:customs:custom-normative-text-declaration':
    'DECLARAÇÃO DE DUPLA UTILIZAÇÃO:',
  'shipping-send-form:customs:custom-normative-text-declaration-body':
    'Alguns produtos/tecnologia (incluindo software) podem destinar‑se a usos militares ou nucleares, pelo que as autoridades aduaneiras exigem uma declaração confirmando que o conteúdo enviado NÃO tem/não terá uso militar.',
  'shipping-send-form:customs:custom-normative-text-cities':
    'DECLARAÇÃO CITES:',
  'shipping-send-form:customs:custom-normative-text-cities-body':
    'As autoridades aduaneiras solicitam uma declaração confirmando que a mercadoria enviada NÃO provém de espécies protegidas ao abrigo do acordo CITES para a proteção de fauna e flora em perigo de extinção.',
  'shipping-send-form:customs:custom-normative-text-waste':
    'DECLARAÇÃO DE RESÍDUOS:',
  'shipping-send-form:customs:custom-normative-text-waste-body':
    'As autoridades aduaneiras solicitam uma declaração confirmando que a mercadoria enviada NÃO constitui resíduos (lixo ou semelhante).',
  'shipping-send-form:customs:custom-normative-text-exportacion':
    'EXPORTAÇÃO PERMANENTE:',
  'shipping-send-form:customs:custom-normative-text-exportacion-body':
    'A CTT Express realiza apenas exportações definitivas/permanentes, ou seja, mercadorias que saem do território aduaneiro para permanecerem definitivamente no exterior.',
  'shipping-send-form:customs:readed':
    'Sim, autorizo a assinatura digital da minha declaração aduaneira.',
  'shipping-send-form:customs:upload-files':
    'Ter a documentação correta é essencial em envios para as Canárias, Ceuta, Melilha e internacionais, para evitar atrasos ou retenções e garantir uma entrega rápida. Aqui pode anexar os documentos necessários, como o Certificado de origem. Lembre‑se de que a documentação anexada não deve incluir impostos.',
  'shipping-send-form:customs:inventory-custom-number': 'Artigo {number}',
  'shipping-send-form:customs:form:type': 'Tipo',
  'shipping-send-form:customs:form:individual': 'Particular',
  'shipping-send-form:customs:form:dni': 'DNI ou passaporte',
  'shipping-send-form:customs:form:reason': 'Motivo do envio',
  'shipping-send-form:customs:form:company': 'Empresa',
  'shipping-send-form:customs:form:company-name': 'Nome da empresa',
  'shipping-send-form:customs:form:bill': 'N.º de fatura',
  'shipping-send-form:customs:form:prosecutor':
    'N.º de identificação fiscal europeu (NIF‑IVA)',
  'shipping-send-form:customs:form:prosecutor-es':
    'N.º de identificação fiscal (NIF)',
  'shipping-send-form:customs:form:category': 'Categoria',
  'shipping-send-form:customs:form:taric_code': 'Código TARIC',
  'shipping-send-form:customs:form:taric_code_alert':
    'Nesta secção, é necessário introduzir o código pautal (n.º TARIC/Tariff), um código internacional utilizado pelas autoridades aduaneiras para classificar mercadorias. Encontre o seu número TARIC introduzindo o conteúdo em inglês na secção “advanced search” de',
  'shipping-send-form:customs:form:taric_code_alert_link': 'ec.europa.eu.',
  'shipping-send-form:customs:form:place': 'Local de fabrico',
  'shipping-send-form:customs:form:description':
    'Descrição do conteúdo (obrigatoriamente em inglês e em maiúsculas)',
  'shipping-send-form:customs:form:description-es':
    'Descrição do conteúdo (obrigatoriamente em maiúsculas)',
  'shipping-send-form:customs:form:description-summary': 'Descrição',
  'shipping-send-form:customs:form:quantity': 'Número de artigos',
  'shipping-send-form:customs:form:price': 'Valor por artigo sem IVA',

  'shipping-send-form:customs:form:select:personal_effects': 'Objetos pessoais',
  'shipping-send-form:customs:form:select:sold': 'Compra/venda',
  'shipping-send-form:customs:form:select:repair_and_return': 'Devolução',
  'shipping-send-form:customs:form:select:sample': 'Amostra',
  'shipping-send-form:customs:form:select:certificate_of_origin':
    'Certificado de origem',
  'shipping-send-form:customs:form:select:other': 'Outro',
  'shipping-send-form:customs:article-number-format-error':
    'Não são permitidos decimais',

  'shipping-send-form:customs:taric-code-empty': 'Este campo é obrigatório',
  'shipping-send-message:weight-1':
    'Peso máximo por volume: 40 kg / Medida máxima por volume: 240 cm (comprimento + largura + altura) e nenhuma dimensão pode exceder 150 cm.',
  'shipping-send-message:weight-2':
    'Peso máximo: 20 kg. Medida máxima por volume: 240 cm (comprimento + largura + altura) e nenhuma dimensão pode exceder 150 cm.',
  'shipping-send-message:weight-3':
    'Peso máximo: 5 kg. Medida máxima por volume: 240 cm (comprimento + largura + altura) e nenhuma dimensão pode exceder 150 cm.',
  'shipping-send-message:weight-4':
    'Peso máximo por volume: 30 kg / Medidas máximas por volume: 40 cm × 30 cm × 30 cm.',
  'shipping-send-message:weight-5':
    'Peso máximo por volume: 10 kg / Medidas máximas por volume: 50 cm × 50 cm × 50 cm.',
  'shipping-send-form:origin-pudo:info-1':
    'Se quiser consultar a lista de pontos de recolha, clique',
  'shipping-send-form:origin-pudo:available-points-link': 'aqui',
  'shipping-send-form:origin-pudo:info-2':
    'Deve cumprir as seguintes características:',
  'shipping-send-form:origin-pudo:max-weight': 'Máximo 20 kg',
  'shipping-send-form:origin-pudo:mono-package': 'Envios de um só volume',
  'shipping-send-form:origin-pudo:max-dimensions': 'Máx. 160 cm (60×40×60)',
  'shipping-send-form:origin-pudo:email-instruction-1_pt':
    'Para depositar a mercadoria,',
  'shipping-send-form:origin-pudo:email-instruction-bold_pt':
    'o remetente deve levar a etiqueta de entrega que será gerada no final do registo deste envio',
  'shipping-send-form:origin-pudo:email-instruction-2_pt':
    'a qualquer um dos pontos disponíveis.',
  'shipping-send-form:origin-pudo:email-instruction-1':
    'Enviaremos a esta pessoa o',
  'shipping-send-form:origin-pudo:email-instruction-bold':
    'código de barras que terá de apresentar',
  'shipping-send-form:origin-pudo:email-instruction-2':
    'para entregar a mercadoria em ',
  'shipping-send-form:origin-pudo:email-instruction-bold-2':
    'qualquer um dos pontos disponíveis',
  'shipping-send-form:origin-pudo:email-instruction-3':
    'sem necessidade de selecionar um ponto antecipadamente.',
  'shipping-send-form:origin-pudo:sender-info':
    'Quem irá depositar a mercadoria?',
  'shipping-send-form:origin-pudo:sender-country':
    'Selecione o país de recolha',
  'shipping-send-form:origin-pudo:sender-country-spain': 'Espanha',
  'shipping-send-form:origin-pudo:sender-country-portugal': 'Portugal',
  'shipping-send-form:origin-pudo:alert':
    'Os volumes devem cumprir as seguintes características: apenas um volume. Máx. 20 kg. Máx. 160 cm (60×40×50).',
  'shipping-send-form:origin-pudo:alert-pt':
    'Nota: Nos Açores, o peso máximo é 5 kg.',
  'shipping-send-form:one-package-alert':
    'As recolhas através dos Pontos CTT Express são de um único volume.',
  'shipping-send-form:label-packages':
    'Lembre‑se de que é obrigatório etiquetar os volumes.',
  'shipping-send-form:fixed-pickup-extra-cost':
    'Tem uma recolha fixa em {dayMonth} das {minHour} às {maxHour}. Lembre‑se de que este pedido pode ter custo adicional.',
  'shipping-send-form:service-price':
    '(*) Tarifa de acordo com os pesos e as medidas indicados.',
  'shipping-send-form:summary-service-price':
    '(*) Tarifa indicativa com base nos pesos e medidas declarados, sujeita a alterações de acordo com as condições contratuais.',
  'shipping-send-form:reference-format-error':
    'A referência só pode conter letras, números, hífenes e underscores',
  'shipping-send-form:format-error': 'Formato incorreto',
  'shipping-send-form:only-number-error': 'Este campo só aceita números.',
  'shipping-send:stored-info':
    'O envio está preparado para entrega ou devolução.',
  // Send summary'
  'shipping-send-summary:legal':
    '<p>Certifique‑se de que todos os dados do seu envio estão corretos. A CTT Express reserva‑se o direito de não proceder à recolha/entrega da embalagem caso as medidas e/ou o peso apresentem uma grande diferença face aos indicados no envio.</p> <p>Lembre‑se também de que os horários podem estar sujeitos a alterações por motivo de força maior.</p>',

  // Send success
  'shipping-send-success:shipping-code': 'Código do envio:',
  'shipping-send-success:shipping-number': 'Número do envio:',
  'shipping-send-success:helper-text':
    'Lembre‑se de que, em <strong>Seguir envio</strong>, pode ver todos os seus envios registados e respetivos estados, bem como imprimir as etiquetas quando quiser.',
  'shipping-send-success:helper-text-2':
    'De seguida, pode imprimir ou descarregar a etiqueta agora.',
  'shipping-send-success:helper-text-origin-pudo':
    'Lembre‑se de que, em <strong>Seguir envio</strong>, pode ver todos os seus envios registados e respetivos estados, bem como imprimir as etiquetas quando quiser.',
  'shipping-send-success:helper-text-mobile':
    'Se quiser consultar mais tarde, enviámos um email com o detalhe do envio.',

  // Cancel shipping
  'shipping-send-cancel:alert-description':
    'Lembre‑se de que apenas é possível anular envios com o estado “Registado”.',

  // Cancel manifest
  'generate-manifest-cancel:alert-description':
    'O manifesto só está disponível para envios com origem e destino na morada do contrato ou noutra morada particular.',

  // Addresses
  'address:without-name': '{address}, {postalCode}, {city}, {country}',
  'address:contract-default': 'Associada ao contrato',
  'address:address-book': 'Associada à sua agenda',

  // Helpers
  'helper:origin': 'De onde envia',
  'helper:destination': 'A quem envia',
  'helper:shipment': 'Diga‑nos como é a mercadoria',
  'helper:customs': 'Documentação para a alfândega',
  'helper:additional-services': 'Como será a entrega',
  'helper:resume': 'Verifique o seu pedido',
  'helper:max-amount': 'Máximo {formattedAmount} €',
  'helper:max-un': 'Máximo {formattedAmount} un.',

  // Placeholders
  'placeholder:client': 'Escreva ou selecione da lista',
  'placeholder:postal-code': '00000 -',
  'placeholder:max-characters': 'Máximo {number} caracteres…',
  'placeholder:date': 'dd/mm/aaaa',
  'placeholder:kilograms': '{number} kg', // TODO: rename
  'placeholder:centimetres': '{number} cm', // TODO: rename
  'placeholder:service-type': 'Escolha um serviço',
  'placeholder:phone': '351.000.000.000',
  'placeholder:search-by-name-or-address': 'Pesquise por nome ou morada',
  'placeholder:search-by-name-or-address-or-code':
    'Pesquise por nome, morada ou código de cliente habitual',
  'placeholder:search-by-name-or-address-or-company':
    'Pesquise por nome ou morada',
  'placeholder:select-country': 'Selecione um país',

  // Tooltips
  'tooltip:locality':
    'Altere o nome da localidade se considerar que o código postal introduzido também corresponde a outro município.',
  'tooltip:go-tracking': 'Ir para Seguir envio',
  'tooltip:delete-file': 'Apagar ficheiro da lista',
  'tooltip:success-files': 'Total de envios registados com sucesso',
  'tooltip:errored-files': 'Total de envios NÃO registados',
  'tooltip:download-CSV':
    'Ficheiro com os envios que deram erro no carregamento',
  'tooltip:processing-request': 'A processar pedido',
  'tooltip:return-shipment': 'Ver envio de devolução',
  'tooltip:schedule': 'Agendar a recolha desta mercadoria',
  'tooltip:not-schedule': 'Não é possível agendar o envio. Centro inativo',
  'tooltip:not-resoluble':
    'NÃO é possível resolver este incidente através deste site',
  'tooltip:resoluble': 'É possível resolver este incidente através deste site',
  'tooltip:solved':
    'Este incidente já tem uma solução e está pendente de execução',
  'tooltip:regular-addresses': 'Esta é a lista das suas moradas habituais.',
  'tooltip:return-email':
    'O remetente receberá uma notificação por email, permitindo escolher a data e/ou a morada de recolha e até selecionar um Ponto CTT Express para nos entregar a mercadoria.',
  'tooltip:measures-price':
    'Preencha o peso e as medidas para conhecer a tarifa do seu envio',
  'tooltip:weigth-price': 'Preencha o peso para conhecer a tarifa do seu envio',
  'tooltip:new-direction':
    'Utilize esta opção se quiser fazer um envio para uma morada que não esteja na sua lista.',
  'tooltip:countries-origin':
    'Os países de origem de um envio são Espanha, Andorra e Portugal',
  'tooltip:service-type':
    'Mostramos os serviços que pode contratar, tendo em conta os dados de origem e destino',
  'tooltip:reference-number':
    'Se adicionar o seu número de referência habitual, poderá pesquisar e encontrar facilmente o seu envio na lista de Seguir envio.',
  'tooltip:purchase-sale':
    'Entendemos por compra/venda o envio de mercadoria em que o destinatário efetuou um pagamento para a receber. Isto não se aplica à compra/venda de artigos em segunda mão entre particulares.',
  'tooltip:custom:nif':
    'Tenha em conta que, se o remetente e/ou o destinatário for uma empresa, deverá indicar o respetivo NIF‑IVA. Consulte a Autoridade Tributária para saber como o solicitar.',
  'tooltip:custom:reason':
    'Indique o motivo do envio com total transparência. Caso contrário, poderão ocorrer atrasos desnecessários. Lembre‑se de que a CTT Express realiza apenas exportações definitivas/permanentes, ou seja, mercadorias destinadas a permanecer fora do território aduaneiro.',
  'tooltip:custom:description':
    'Lembre‑se de incluir a descrição em inglês e em maiúsculas para cada artigo do envio (se precisar de ajuda, pode usar um tradutor). A descrição deve indicar o que é, o material de que é feito e a sua utilização (se aplicável). Exemplo: “WOMEN’S TENNIS SHOES / BLUE / BOVINE LEATHER / NEW”.',
  'tooltip:custom:description-es':
    'A descrição deve indicar o que é, o material de que é feito e a sua utilização (se aplicável). Exemplo: “SAPATILHAS DE DESPORTO DE SENHORA / AZUIS / EM COURO / NOVAS”.',
  'tooltip:custom:quantity':
    'Ao indicar o número de artigos, se forem exatamente iguais, basta introduzir o produto uma vez e indicar a quantidade (por exemplo, 2 t‑shirts de algodão idênticas).',
  'tooltip:custom:price':
    'Todos os produtos devem ter um valor, mesmo em caso de devolução, amostra ou oferta (não é permitido indicar 0 €). Indique o valor real de cada artigo para evitar pedidos adicionais da alfândega e possíveis atrasos.',
  'tooltip:custom:place':
    'Indique o país de fabrico do produto. Caso não seja o fabricante, poderá encontrar essa informação na documentação ou na etiqueta “Made in”.',
  'tooltip:mobile-phone': 'Apenas números de telemóvel recebem notificações',
  // Alerts
  // Alerts
  'alert:document':
    'Consideramos documento qualquer envio em papel com peso inferior a 10 kg. Tudo o restante é considerado mercadoria.',
  'alert:merchandise':
    'Lembre‑se de que, consoante o destino, alguns tipos de mercadoria podem estar sujeitos a restrições ou condições especiais. Caso o envio não seja possível por restrições legais, entraremos em contacto consigo com a maior brevidade possível.',
  'alert:no-products':
    'Não existem produtos disponíveis para a origem e destino selecionados. Contacte a sua pessoa de contacto.',
  'alert:environment-error':
    'Estamos a configurar o site. Por favor, tente mais tarde.',
  'alert:go-to-download-page': 'Ir para a página de download',
  'alert:shippings-search:no-shippings':
    'Não existe nenhum pedido com essa referência. Verifique ou tente outro número.',

  // Service types
  'service-type:24h': '24 horas',
  'service-type:weekend': 'Fim de semana',

  // Other services
  'service:with-return': 'Envio com retorno',
  'service:with-handling': 'Com manuseamento',
  'service:scan-client-slip': 'Digitalização da guia do cliente',
  'service:verify-code': 'Verificação QR, Bidi…',
  'service:rdp-send': 'Recolha direta em Ponto CTT Express',

  // Download filenames
  'shipping-send:label:filename': 'ctt-etiqueta-{id}.pdf',

  'shipping:extension-error':
    'Este ficheiro não tem um formato válido. Os formatos aceites são .DOC, .DOCX, .XLS, .XLSX, .TXT, .RTF, .JPG, .GIF, .BMP, .TIF, .PNG ou .PDF.',
  'shipping:size-error':
    'Este ficheiro é demasiado grande. Reduza o tamanho ou selecione um ficheiro mais pequeno. Pode carregar ficheiros até 5 MB.',
  'shipping:upload-error':
    'Ocorreu um erro durante a importação. Atualize a página, importe novamente o ficheiro ou tente mais tarde.',
  'shipping:name-error':
    'O nome do ficheiro excede o comprimento máximo permitido de 244 caracteres.',

  //Agenda
  'agenda:title': 'Agenda',
  'agenda:description':
    'Aqui pode gerir os seus contactos ou importá‑los de forma massiva através de um ficheiro.',
  'agenda:import-contacts': 'Importar contactos',
  'agenda:add-contact': 'Adicionar contacto',
  'agenda:edit-contact': 'Editar contacto',
  'agenda:select-center': 'Ver agenda de:',
  'agenda:empty-state': 'Ainda não tem contactos nesta agenda',
  'agenda:add-success': 'O contacto foi adicionado com sucesso.',
  'agenda:add-error':
    'Não foi possível adicionar o contacto. Tente novamente mais tarde.',
  'agenda:edit-success': 'O contacto foi atualizado com sucesso.',
  'agenda:edit-error':
    'Não foi possível editar o contacto. Tente novamente mais tarde.',
  'agenda:delete-file-success': 'O ficheiro foi eliminado com sucesso.',
  'agenda:delete-file-error':
    'Não foi possível eliminar este ficheiro. Tente novamente mais tarde.',
  'agenda:delete-file': 'Quer eliminar este ficheiro?',
  'agenda:delete-file-body1':
    'Ao confirmar, irá apenas eliminar o ficheiro do registo de importação. Os contactos importados manter‑se‑ão guardados na agenda.',
  'agenda:delete-file-body2':
    'Se pretender eliminar um contacto, deve fazê‑lo na área {myAgenda}.',
  'agenda:import-description':
    'Adicione contactos à sua agenda de forma massiva, importando um ficheiro em três passos simples.',
  'agenda:how-import': 'Como importar?',
  'agenda:step-1': 'Selecione um centro',
  'agenda:step-2-1': 'Descarregue o nosso {csv} de referência',
  'agenda:step-2-2': 'ficheiro',
  'agenda:step-3': 'Registe os contactos no modelo',
  'agenda:step-2-3':
    'Para evitar erros, recomendamos a utilização deste modelo',
  'agenda:step-4': 'Importe ou arraste o modelo',
  'agenda:info': 'Para mais informações, descarregue o nosso tutorial',
  'agenda:succesfull-title': 'O pedido de carregamento está a ser processado',
  'agenda:succesfull-body':
    'Estamos a verificar o ficheiro. Iremos mostrar os contactos carregados corretamente e, nos restantes, será indicado o tipo de erro.',
  'agenda:succesfull-next-page': 'página seguinte',
  'agenda:massive-request': 'Gerar uma nova importação de contactos',
  'agenda:save-time': 'e poupe tempo no processo de adição de contactos.',
  'agenda:import-your-file': 'Importe o seu ficheiro',
  'agenda:center-to-import':
    'Selecione o centro ao qual serão adicionados os contactos',
  'agenda:center-error':
    'Deve selecionar um centro ao qual adicionar os contactos.',
  'agenda:extension-error':
    'Este ficheiro não tem um formato válido. O formato aceite é .xlsx.',
  'agenda:format-error': 'O ficheiro importado tem um formato incorreto.',

  //Shipping Recording
  'shipping-recording:title': 'Importação massiva de envios',
  'shipping-recording:import-file': 'Importação de ficheiro',
  'shipping-recording:importation-progress': 'Importação de envios em curso',
  'shipping-recording:select-method':
    'Selecione um dos métodos para carregar os seus envios',
  'shipping-recording:select-multiple-centers-1':
    'Multicentro: um único ficheiro para todos os centros',
  'shipping-recording:select-multiple-centers-2':
    'Deve incluir no ficheiro o código do centro associado a cada envio.',
  'shipping-recording:select-one-center-1':
    'Por centro: um ficheiro separado para cada centro',
  'shipping-recording:select-one-center-2':
    'Deve selecionar o centro ao qual associar o ficheiro que anexar.',
  'shipping-recording:description':
    'Solicite de forma massiva os seus envios para Espanha e Portugal, importando um ficheiro.',
  'shipping-recording:massive-request': 'Gerar um novo pedido massivo',
  'shipping-recording:import-your-file': 'Importe o seu ficheiro',
  'shipping-recording:save-time':
    'e poupe tempo no processo de pedido dos seus envios.',
  'shipping-recording:how-import': 'Como importar?',
  'shipping-recording:step-1-1': 'Descarregue o {csv}.',
  'shipping-recording:step-1-2': 'este ficheiro',
  'shipping-recording:step-2': 'Complete a informação dos seus envios',
  'shipping-recording:step-2-alter':
    'Complete o ficheiro, incluindo o centro de imputação de cada envio.',
  'shipping-recording:step-3-alter': 'Carregue o ficheiro',
  'shipping-recording:step-3':
    'Selecione o centro de imputação e carregue o ficheiro.',
  'shipping-recording:step-3-1':
    'Lembre‑se de incluir envios de um único centro por ficheiro.',
  'shipping-recording:step-3-1-alter':
    'Cada envio será imputado ao centro indicado na coluna “Cliente Centro”.',
  'shipping-recording:info': 'Para mais informações, descarregue o {tutorial}.',
  'shipping-recording:tutorial': 'o nosso tutorial',
  'shipping-recording:select-center': 'Selecione o centro de imputação',
  'shipping-recording:delete-file-success':
    'O ficheiro foi eliminado com sucesso.',
  'shipping-recording:delete-file-error':
    'Não foi possível eliminar este ficheiro. Tente novamente mais tarde.',
  'shipping-recording:center-error':
    'Deve selecionar um centro ao qual imputar os envios.',
  'shipping-recording:delete-file': 'Quer eliminar este ficheiro?',
  'shipping-recording:delete-file-body1':
    'Lembre‑se de que irá apenas eliminar o ficheiro desta lista, o que não afeta os envios.',
  'shipping-recording:delete-file-body2':
    'Os envios solicitados corretamente não serão afetados. Se pretender anular algum envio carregado com este ficheiro, aceda à secção {shippingTracking}.',
  'shipping-recording:succesfull-title':
    'O pedido de carregamento foi recebido com sucesso!',
  'shipping-recording:succesfull-body':
    'Estamos a processar o conteúdo do seu ficheiro. Pode consultar o estado deste processo de seguida.',
  'shipping-recording:succesfull-alert':
    '<p> Iremos recolher a sua mercadoria na primeira data disponível. </p> <p> Lembre‑se de que, se tiver uma Recolha fixa definida, a mercadoria será recolhida no horário e morada habituais. </p>',
  'shipping-recording-schedule-2':
    'Vamos recolher a mercadoria no próximo horário disponível para cada morada de origem indicada.',
  'shipping-recording-schedule-1':
    'A data e a hora serão calculadas tendo em conta o código postal e o horário de registo.',
  'shipping-recording:asap-warning':
    'Para cada envio, será calculada a data e hora mais cedo possível, tendo em conta o código postal e o horário de registo.',
  'shipping-recording:asap-warning-2':
    'Tenha em conta que o tempo mínimo para o distribuidor recolher a mercadoria é de 1 hora após o processamento do pedido.',
  'shipping-recording:asap-info':
    'Para saber a data exata de recolha de cada envio, deve aceder à secção Seguir envio após o processamento do pedido.',
  'shipping-recording:later-warning':
    'Lembre‑se de que pode programar esta recolha no detalhe do envio e na secção Seguir envio. Ficamos a aguardar as suas indicações para que os nossos distribuidores efetuem a recolha.',
  'shipping-recording:later-info':
    'Para saber a data exata de recolha de cada envio, deve aceder à secção Seguir envio após o processamento do pedido.',
  'shipping-recording:choose-info':
    'Para saber a data exata de recolha de cada envio, deve aceder à secção Seguir envio após o processamento do pedido.',
  'shipping-recording:extension-error':
    'Este ficheiro não tem um formato válido. Os formatos aceites são .csv, .xls ou .xlsx.',
  'shipping-recording:size-error':
    'Este ficheiro é demasiado grande. Por favor, reduza o tamanho ou selecione um ficheiro mais pequeno. Pode carregar ficheiros até 5 MB.',
  'shipping-recording:upload-error':
    'Ocorreu um erro durante o processo de importação. Atualize a página, importe novamente o ficheiro ou tente mais tarde.',
  'shipping-recording:line-error':
    'O ficheiro excede o número máximo de envios permitidos. Certifique‑se de que o documento não contém mais de 500 envios.',
  'shipping-recording:pickup-date':
    'Vamos recolher no dia {date} das {minHour} às {maxHour}.',
  'shipping-recording:size-text': 'Máximo de 500 envios por ficheiro.',
  //Reports
  'reports:title': 'Relatórios',
  'reports:description':
    'Subscreva e receba diariamente os relatórios dos seus envios.',
  'reports:description-2':
    'Pode descarregar gratuitamente os relatórios, nesta secção ou através de SFTP com as credenciais que enviaremos por email.',
  'reports:confirm-sub-title': 'Confirme a ativação desta subscrição',
  'reports:confirm-unsub-title': 'Pretende desativar esta subscrição?',
  'reports:confirm-sub-description':
    'Terá relatórios diários disponíveis na lista de relatórios.',
  'reports:confirm-unsub-description':
    'Se continuar, deixará de receber estes relatórios e não poderá aceder aos anteriores. Pode voltar a ativar a subscrição a qualquer momento.',
  'reports:config-report': 'Configuração da frequência',
  'reports:frequency': 'Frequência',
  'reports:day': 'Dia',
  'reports:days': 'Dias',
  'reports:week': 'Semana',
  'reports:daily': 'Diário',
  'reports:weekly': 'Semanal',
  'reports:month': 'Mensal',
  'reports:hour': 'Hora',

  // Shipping Tracking
  'shipping-tracking:shipping-selected':
    'Selecionou um total de {shippingCount, plural, one {{shippingCount} envio} other {{shippingCount} envios}}. {text}',
  'shipping-tracking:shipping-selected-2':
    'Utilize os filtros para realizar outra seleção.',
  'shipping-tracking:shipping-selected-3':
    'Selecione todos os envios com este filtro.',
  'shipping-tracking:title': 'Seguir envio',
  'shipping-tracking:description':
    'Nesta lista pode acompanhar o estado de todos os seus envios.',
  'shipping-tracking:find-shipments':
    'Configure o filtro para visualizar ou descarregar os seus envios',
  'shipping-tracking:by-shipment': 'Por envio',
  'shipping-tracking:search-in-the-incidents': 'Pesquisar nos incidentes',
  'shipping-tracking:show-incidents': 'Mostrar apenas envios com incidentes',
  'shipping-tracking:current-status': 'Este é o estado atual do seu envio',
  'shipping-tracking:tracking': 'Seguir envio',
  'shipping-tracking:shipment-step-by-step': 'O seu envio passo a passo',
  'shipping-tracking:see-complete-tracking': 'Ver seguimento completo',
  'shipping-tracking:support-link': 'Precisa de ajuda com este envio?',
  'shipping-tracking:pickup:success:title':
    'O seu envio chegará na data prevista',
  'shipping-tracking:returned:title':
    'O seu envio foi devolvido ao ponto de origem e chegará em',
  'shipping-tracking:pickup:not-defined': 'Não definida',
  'shipping-tracking:pickup:no-delivery-date:subtitle':
    'Poderemos indicar a data estimada de entrega assim que recolhermos o pedido.',
  'shipping-tracking:pickup:error:subtitle':
    'Lamentamos, o seu envio poderá demorar mais do que o previsto.',
  'shipping-tracking:send:success:title': 'O envio foi entregue com sucesso',
  'shipping-tracking:send:no-delivery-date:title':
    'Ainda não existe uma data de recolha programada.',
  'shipping-tracking:send:inactive:title': 'O centro encontra‑se inativo.',
  'shipping-tracking:send:inactive:subtitle':
    'Não é possível programar o envio porque o centro está inativo.',
  'shipping-tracking:send:stored': 'O envio encontra‑se {eventName}',
  'shipping-tracking-chip:service-type': 'Tipo de serviço',
  'shipping-tracking-chip:postal-code': 'Código postal',
  'shipping-tracking-chip:origin-postal-code': 'Código postal de origem',
  'shipping-tracking-chip:destin-postal-code': 'Código postal de destino',
  'shipping-tracking-chip:center-code': 'Código do centro do cliente',
  'shipping-tracking-chip:country': 'País',
  'shipping-tracking-chip:shipping-code-or-reference':
    'Número de envio ou referência',
  'shipping-tracking:cancelled:title': 'O seu envio foi anulado em:',
  'shipping-tracking:cancelled:subtitle':
    '{datetime, date, ::ddMMyyyy} | {datetime, date, ::kkmm}',
  'shipping-tracking:check-pickup-address':
    'Verifique a morada de recolha da mercadoria.',
  'shipping-tracking:if-insert-address-is-not-correct-create-new-shipping':
    'Se a morada inserida não estiver correta, é necessário criar um novo envio.',
  'shipping-tracking:if-address-is-correct-contact-customer-support':
    'Se a morada estiver correta, contacte o apoio ao cliente para resolver este incidente.',
  'shipping-tracking:already-resolved':
    'Já foi realizada uma ação sobre este incidente e o envio continua o seu percurso. Em breve será apresentado o novo estado.',
  'shipping-tracking:error-file':
    'Não foram encontrados envios para o filtro selecionado.',
  'shipping-tracking:error-date':
    'Não é possível descarregar um intervalo superior a 31 dias.',
  'shipping-tracking:error-unexpected':
    'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.',
  'shipping-tracking:error-date-range':
    'Não é possível apresentar um intervalo superior a 7 dias.',
  'shipping-tracking:error-date-range-31':
    'Não é possível apresentar um intervalo superior a 31 dias.',

  // Tracking
  'tracking:incorrect_address': 'Morada incompleta/incorreta',
  'tracking:no_answer': 'O destinatário não responde',
  'tracking:no_answer_r': 'O remetente não responde',
  'tracking:refuses': 'Recusado',
  'tracking:no_effective': 'Sem numerário na entrega',
  'tracking:pending': 'Pendente de entrada na rede',
  'tracking:recorded': 'Registado',
  'tracking:collected': 'Recolhido',
  'tracking:merchandise-origin': 'Mercadoria na delegação de origem',
  'tracking:merchandise-destination': 'Mercadoria na delegação de destino',
  'tracking:in-transit': 'Em trânsito',
  'tracking:available': 'Disponível para recolha',
  'tracking:distribution': 'Em distribuição',
  'tracking:stored': 'Armazenado',
  'tracking:manifested': 'Manifestados',
  'tracking:pudo': 'Disponível em Ponto Pick&Drop',
  'tracking:delivered': 'Entregue',
  'tracking:returned': 'Devolvido',
  'tracking:depositPending': 'Anulado',
  'tracking:deposited': 'Depositado num Ponto Pick&Drop',
  'tracking:delivered-plural': 'Entregues',
  'tracking:cancelled': 'Anulado',
  'tracking-line:shipping-cancelled': 'Envio anulado',
  'tracking-line:shipping-unscheduled': 'Sem agendamento',
  'separator:pudo': 'Recolha em Ponto CTT',
  'tracking-line:pickup-unscheduled': 'Recolha sem agendamento',
  'tracking-line:shipped': 'Em trânsito',
  'tracking-table:information': 'Informação',
  'tracking-table:info:atc': 'Alteração realizada pela equipa de Apoio ao Cliente',
  'tracking-table:info:client-web': 'Alteração realizada a partir da área privada de clientes',
  'tracking-table:info:recipient': 'Alteração realizada pelo destinatário',
  'date-digest:title:expected-delivery-date': 'Data prevista de entrega',
  'date-digest:title:delivered-date': 'Data de entrega',
  'date-digest:title:cancellation-date': 'Data da anulação do envio',
  'date-digest:body:not-defined-date': 'Não definida.',
  'date-digest:body:unscheduled-date':
    'Ainda não existe uma data de recolha programada. Poderemos indicar a data estimada de entrega assim que recolhermos o seu pedido.',
  'date-digest:body:inactive':
    'Não é possível programar o envio porque o centro está inativo.',
  'date-digest:body:delivery-date':
    '{isTomorrow, select, true {Amanhã, } other {} }{weekDay} <strong>{date, date, ::ddMMyyyy}</strong>',
  'date-digest:body:cancellation-date':
    '<strong>{datetime, date, ::ddMMyyyy}</strong> {datetime, date, ::kkmmss}',
  'date-digest:footer:not-recoverable-warning':
    'Os envios anulados não podem ser recuperados',

  // Detail
  'shipping-detail:title': 'Detalhe do envio',
  'shipping-detail:shipment-number': 'N.º do envio:',
  'shipping-detail:return-number': 'N.º do envio devolvido:',

  'shipping-detail:original-number': 'N.º do envio original:',
  'shipping-detail:pt': 'N.º do envio português:',
  'shipping-detail:see-return': 'Ver devolução',
  'shipping-detail:ctt-express-point': 'Ponto CTT Express',
  'shipping-detail:delivery-location': 'Local de entrega',
  'shipping-detail:delivery-location-description':
    'De seguida, pode conhecer com precisão o local de entrega do seu envio.',
  'shipping-detail:delivery-date': 'Data de entrega',
  'shipping-detail:delivery-address': 'Morada de entrega',
  'shipping-detail:view-delivery-location': 'Ver local de entrega',
  'shipping-detail:delivery-location-unavailable':
    'Não é possível aceder ao local de entrega',
  'shipping-detail:delivery-location-reason:locker':
    'O envio foi entregue num Locker',
  'shipping-detail:delivery-location-reason:pudo':
    'O envio foi entregue num ponto Pick&Drop',
  'shipping-detail:delivery-location-reason:lobby':
    'O envio foi entregue na portaria',
  'shipping-detail:delivery-location-reason:neighbor':
    'O envio foi entregue a um vizinho de acordo com as instruções indicadas.',
  'shipping-detail:additional-info': 'Informação adicional:',

  // Home
  'home:title': 'Início',
  'home:welcome':
    '{name, select, unnamed {Bem‑vindo} other {Bem‑vindo, {name}} }',
  'home:your-activity': 'Esta é a sua atividade no último mês.',
  'home:your-activity-s': 'Esta é a sua atividade na última semana.',
  'home:shipment-status': 'Situação dos envios',
  'home:shipment-locator': 'Localizador de envios',
  'home:shipment-locator-subtitle':
    'Informação atualizada de todos os seus envios.',
  'home:find-shipment': 'Encontre o envio que procura',
  'home:result-shipment': 'Resultado da pesquisa',
  'home:shipment-search-results': 'Este é o resultado da sua pesquisa',
  'home:shipment-locator-input-helper':
    'Lembre‑se de que pode introduzir o número de envio ou a referência completa, ou apenas uma parte.',
  'home:shipment-locator-input-helper-mobile':
    'Deve introduzir o número completo',
  'home:shipment-locator-input-placeholder':
    'N.º do envio ou n.º de referência',
  'home:shipment-recording-input-placeholder': 'Nome do ficheiro',
  'home:filters': 'Filtrar {type} por',
  'home:filters:delete': 'Limpar todos os filtros',
  'home:latest-incidents': 'Últimos incidentes',
  'home:latest-shipments': 'Últimos envios',
  'home:no-results':
    'Não existe nenhum pedido com esse número. Verifique ou tente outro número.',
  'home:view-complete-list': 'Ver lista completa de envios',
  'home:total-shipments': 'Total de envios',
  'home:promo-banner-line1-start': 'Agora os destinatários podem pagar',
  'home:promo-banner-line2': 'o reembolso com cartão contactless',

  // Billing
  'billing:title': 'Faturação',
  'billing:subtitle':
    'Aqui pode consultar a sua tarifa contratada. Se tiver alguma dúvida sobre tarifas, produtos e/ou serviços, o seu consultor comercial poderá ajudar.',
  'billing:filter-client-center': 'Por código do centro do cliente',
  'billing:see-my-rate-2023': 'Ver o meu preço 2023',
  'billing:see-my-rate-2024': 'Ver o meu preço   2024',
  'billing:see-my-rate-2025': 'Ver o meu preço  2025',
  'billing:see-my-rate-2026': 'Ver o meu preço  2026',
  'billing:apply-from': 'Aplica a partir de 01/01/26',
  'billing:select-bill': 'Selecionar preço…',
  'billing:select-invoice': 'Selecionar preço',
  'billing:see-invoices': 'Aqui pode consultar os seus preços',
  'billing:see-rates': 'Quadros preçário contratados',
  'billing:no-rates-available':
    'Não existem preços disponíveis para o ano selecionado.',

  //Reports
  'reports:empty-reports': 'Não tem relatórios disponíveis',
  'reports:empty-reports-description':
    'Configure os relatórios aos quais pretende subscrever‑se.',
  'reports:empty-reports-tooltip':
    'As subscrições são uma funcionalidade da sua Área de Cliente que permite receber grandes volumes de dados de forma automática e periódica.',
  'reports:config': 'Subscrição de relatórios',

  // Empty states
  'empty:no-shipment-request': 'Não tem pedidos de envio',
  'empty:no-incident-shipments': 'Não tem incidentes nos seus envios',
  'empty:want-first-shipment': 'Quero fazer o meu primeiro envio agora',
  'empty:no-shippings-title': 'Não existem envios para mostrar',
  'empty:no-results': 'Não existem envios para mostrar',
  'empty:no-results-address-book': 'Não foram encontrados endereços',
  'empty:no-results-search':
    'Não existe nenhum pedido com esta referência. Verifique ou tente outro número.',
  'empty:no-shippings': 'Ainda não realizou nenhum envio',
  'empty:no-incidents': 'Não tem incidentes nos seus envios',
  'empty:no-returns-title': 'Não existem devoluções para mostrar',
  'empty:no-returns-subtitle': 'Ainda não foi realizada nenhuma devolução',
  'empty:no-unscheduled-subtitle':
    'Todos os seus envios têm uma data de recolha programada.',
  'empty:try-another-search': 'Pode tentar outra pesquisa ou voltar à lista.',
  'empty:try-another-search-address-book':
    'Verifique os dados introduzidos ou crie um novo endereço.',
  'empty:back-to-list': 'Voltar à lista completa',
  'empty:everything-goes-smoothly': 'Está tudo a correr sobre rodas!',
  'empty:no-invoices': 'Não encontrámos faturas com os filtros aplicados',
  'empty:no-centers': 'Conta temporariamente inativa',
  'empty:no-centers-body':
    'A sua conta encontra‑se temporariamente inativa. Para resolver e reativar, contacte o seu gestor de conta.',

  // Session
  'session:about-to-expire': 'A sua sessão está prestes a expirar',
  'session:protect-data':
    'Para proteger os seus dados, se não detetarmos atividade, a sessão será encerrada no tempo indicado.',
  'session:if-session-closed': 'Se a sessão for encerrada,',
  'session:you-will-lose-data': 'perderá os dados do seu pedido',
  'session:continue': 'Continuar com a sessão ativa',
  'session:make-sure-completed-request':
    'Certifique‑se de que concluiu o registo do pedido e/ou a sua consulta antes de a sessão ser encerrada',

  // Help
  'help:contact-support': 'Contacto e suporte',
  'help:solve-doubts': 'Aqui pode esclarecer todas as suas dúvidas.',
  'help:attend-email': 'Também prestamos apoio por email',
  'help:solve-problems-remotely': 'Resolvemos o seu problema remotamente',

  'help:team-viewer-download': 'Descarregar TeamViewer',
  'help:any-desk-download': 'Descarregar AnyDesk',
  'help:what-is-remote-control': 'O que é o controlo remoto?',
  'help:remote-control-info':
    'Através de aplicações de controlo remoto, como o TeamViewer, podemos ajudá‑lo a resolver os seus problemas de forma rápida e eficaz, garantindo a sua privacidade de acordo com a <link>legislação em vigor</link>.',
  'help:minimum-system-requirements': 'Requisitos mínimos do sistema:',
  'help:browsers': 'Windows 7, Windows 8, Windows 8.1, Windows 10',
  'help:browsers-2':
    'Navegador Internet Explorer 9 ou superior, Mozilla Firefox, Chrome, etc.',
  'help:user-manual': 'Descarregue o manual do utilizador',
  'help:remote-support': 'Suporte remoto',
  'help:new-user-manual-alert':
    'Atualizámos a nossa plataforma. Conheça as novas funcionalidades. <link>Descarregue aqui o manual do utilizador</link>.',
  'help:user-manual-info':
    'O manual ajuda‑o a esclarecer dúvidas sobre o nosso site.',
  'help:write-your-message-here': 'Deixe‑nos a sua mensagem aqui',
  'help:user-manual-download': 'Descarregar manual do utilizador CTT',
  'help:customer-support': 'Apoio ao cliente',
  'help:informatic-support': 'Suporte Técnico Web',
  'help:other-integrations': 'Outras integrações',
  'help:commercial': 'Comercial',
  'help:billing': 'Faturação',
  'help:area': 'Área',
  'help:reason': 'Motivo',
  'help:contact-form-info':
    'Não utilizaremos o seu email nem o seu telefone para qualquer finalidade que não esteja relacionada com este pedido.',
  'help:send': 'Enviar',
  'help:download-user-manual': 'Descarregar Manual do Utilizador',
  'help:see-videos': 'Ver vídeos explicativos',
  'help:videos': 'Vídeos explicativos',
  'help:videos-text':
    'Através dos vídeos seguintes, pode aprender em poucos minutos qualquer funcionalidade desta aplicação:',
  'help:success-form-sent':
    'Recebemos a sua mensagem.Entraremos em contacto consigo brevemente',
  'help:subject:placeholder': 'Motivo resumido do pedido',
  'help:description:placeholder': 'Descreva aqui o detalhe da sua mensagem.',
  'help:shipmentNumber:placeholder': 'Introduza o número do envio',
  'help:claim-shipment-success': 'O seu pedido foi enviado',
  'help:claim-shipment-success-body':
    'O seu pedido foi registado com sucesso. <p>Responderemos com a maior brevidade possível.</p>',
  'help:claim-shipment-error': 'Erro ao enviar o pedido',
  'help:claim-shipment-error-body':
    'Não foi possível registar o seu pedido. <p>Por favor, tente novamente dentro de alguns minutos.</p>',
  'help:claim-shipment-save': 'As alterações efetuadas não serão guardadas',
  'help:claim-shipment-save-body':
    'Se regressar ao ecrã anterior, perderá a informação introduzida.',
  'help:shipping-tracking-c-2':
    'O incidente indicado não está correto e preciso que recolham o envio.',
  'help:shipping-tracking-c-3':
    'Solicitei uma recolha, mas não passaram pela morada indicada.',
  'help:shipping-tracking-c-1':
    'O envio surge como recolhido, mas ninguém passou para o recolher.',
  'help:shipping-tracking-c-4': 'Preciso de ajuda para resolver um incidente.',
  'help:shipping-tracking-c-5':
    'Preciso de ajuda com uma recolha num Ponto Pick&Drop.',
  'help:shipping-tracking-c-6':
    'O distribuidor teve um comportamento inadequado.',

  'help:shipping-tracking-d-1':
    'O envio não chegou, embora já devesse ter sido entregue.',
  'help:shipping-tracking-d-2':
    'O incidente indicado na entrega não está correto.',
  'help:shipping-tracking-d-3': 'Preciso de ajuda para resolver um incidente.',
  'help:shipping-tracking-d-4':
    'Preciso de ajuda com uma entrega num Ponto Pick&Drop.',
  'help:shipping-tracking-d-5':
    'O envio surge como entregue, mas o destinatário não o recebeu.',
  'help:shipping-tracking-d-6': 'O envio chegou danificado.',
  'help:shipping-tracking-d-7':
    'O distribuidor teve um comportamento inadequado.',
  'help:shipping-tracking-alert':
    'Não utilizaremos o seu email nem o seu telefone para qualquer finalidade que não esteja relacionada com este pedido.',
  // Business
  'shipping-state:WEB0000:name': 'MANIFESTADO',
  'shipping-state:WEB0000:description':
    'ENVIO REGISTADO: CTT EXPRESS A AGUARDAR A RECEÇÃO DA MERCADORIA',
  'shipping-state:WEB0100:name': 'ORDEM DE RECOLHA',
  'shipping-state:WEB0100:description':
    'RECOLHA REGISTADA: CTT EXPRESS A AGUARDAR A RECOLHA DA MERCADORIA',
  'shipping-state:WEB0200:name': 'RECOLHA PENDENTE DE ACEITAÇÃO',

  'shipping-state:WEB0300:name': 'RECOLHA ATRIBUÍDA',
  'shipping-state:WEB0300:description': 'RECOLHA ATRIBUÍDA AO DISTRIBUIDOR',
  'shipping-state:WEB0400:name': 'RECOLHA ANULADA',
  'shipping-state:WEB0400:description': 'RECOLHA ANULADA',
  'shipping-state:WEB0500:name': 'ENVIO RECOLHIDO',
  'shipping-state:WEB0500:description': 'RECOLHA EFETUADA',
  'shipping-state:WEB0600:name': 'RECOLHA FALHADA',
  'shipping-state:WEB0600:description': 'RECOLHA FALHADA',
  'shipping-state:WEB0700:name': 'DELEGAÇÃO DE ORIGEM',
  'shipping-state:WEB0700:description': 'MERCADORIA NA DELEGAÇÃO DE ORIGEM',
  'shipping-state:WEB0800:name': 'EM CARGA',

  'shipping-state:WEB0900:name': 'EM TRÂNSITO',
  'shipping-state:WEB0900:description': 'ENVIO EM CURSO',
  'shipping-state:WEB1000:name': 'PLATAFORMA DE TRÂNSITO',

  'shipping-state:WEB1100:name': 'TRÂNSITO INCORRETO “SOBRA”',
  'shipping-state:WEB1100:description': 'ENVIO COM TRÂNSITO INCORRETO',
  'shipping-state:WEB1200:name': 'DELEGAÇÃO DE DESTINO',
  'shipping-state:WEB1200:description': 'MERCADORIA NA DELEGAÇÃO DE DESTINO',
  'shipping-state:WEB1300:name': 'DISTRIBUIÇÃO PRÉ‑ATRIBUÍDA',

  'shipping-state:WEB1400:name': 'DISTRIBUIÇÃO ATRIBUÍDA',
  'shipping-state:WEB1400:description': 'ENVIO ATRIBUÍDO AO DISTRIBUIDOR',
  'shipping-state:WEB1500:name': 'EM DISTRIBUIÇÃO',
  'shipping-state:WEB1500:description': 'ENVIO EM DISTRIBUIÇÃO',
  'shipping-state:WEB1600:name': 'DISTRIBUIÇÃO FALHADA',
  'shipping-state:WEB1600:description': 'DISTRIBUIÇÃO FALHADA',
  'shipping-state:WEB1700:name': 'ESTACIONADO',
  'shipping-state:WEB1700:description':
    'ENVIO ARMAZENADO TEMPORARIAMENTE (“LOCALIZAÇÃO”)',
  'shipping-state:WEB1800:name': 'ESTACIONADO LOCALIZADO',

  'shipping-state:WEB1900:name': 'PENDENTE DE EXTRAÇÃO',

  'shipping-state:WEB2000:name': 'ENTREGA A COLABORADOR',
  'shipping-state:WEB2000:description':
    'ENTREGUE A COLABORADOR DE DISTRIBUIÇÃO',
  'shipping-state:WEB2100:name': 'ENTREGA EFETUADA',

  'shipping-state:WEB2200:name': 'ENTREGA PARCIAL',
  'shipping-state:WEB2200:description': 'ENTREGUE PARCIALMENTE',
  'shipping-state:WEB2310:name': 'DEPOSITADO EM PONTO CTT',
  'shipping-state:WEB2310:description': 'DISPONÍVEL PARA RECOLHA',
  'shipping-state:WEB2400:name': 'NOVA DISTRIBUIÇÃO',
  'shipping-state:WEB2400:description': 'MERCADORIA NA DELEGAÇÃO DE DESTINO',
  'shipping-state:WEB2500:name': 'DEVOLUÇÃO',
  'shipping-state:WEB2500:description': 'ENVIO DEVOLVIDO',
  'shipping-state:WEB2600:name': 'REEXPEDIDO/RECANALIZADO',

  'shipping-state:WEB2700:name':
    'ARMAZÉM REGULADOR (“NÃO REALIZADO”, “DESTRUÍDO”)',
  'shipping-state:WEB2700:description':
    'PROCESSO DE INCIDENTE ENCERRADO: incidente encerrado e tratado com a origem. Contacte o remetente para mais informações.',
  'shipping-state:WEB2800:name': 'NÃO LOCALIZADO',
  'shipping-state:WEB2800:description':
    'LOCALIZAÇÃO NÃO CONFIRMADA: ocorreu um incidente no trânsito do envio. Por favor, contacte o remetente. Pode consultar o estado atualizado do envio em www.cttexpress.com',
  'shipping-state:WEB2900:name': 'RECOLHER EM DELEGAÇÃO',

  // Print settings
  'print-settings:title': 'Definições de impressão',
  'print-settings:label-printing-configuration':
    'Configuração de impressão de etiquetas',
  'print-settings:problems-installing-the-app':
    'Tem problemas a instalar a aplicação?',
  'print-settings:app-jspm-no-installed':
    'Ao que parece, ainda não instalou a aplicação JSPM ou esta não se encontra atualizada. Lembre‑se de reiniciar o navegador após a instalação do componente.',
  'print-settings:app-jspm-explanation':
    'Para simplificar o processo de impressão de etiquetas, sobretudo se tiver um elevado volume de pedidos, recomendamos a instalação da aplicação JSPrintManager, que facilita a impressão das etiquetas.',

  'print-settings:install-jsprintmanager':
    'Instalar a aplicação JSPrintManager',
  'print-settings:printer': 'Impressora',
  'print-settings:no-printer': 'Não existem impressoras configuradas',
  'print-settings:reload-printers': 'Atualizar lista de impressoras',
  'print-settings:print-type': 'Tipo de impressão',
  'print-settings:print-model': 'Modelo de impressão',
  'print-settings:model-single': 'A6 (10,5 × 14,8 cm)',
  'print-settings:model-single-description': '1 etiqueta por página',
  'print-settings:model-multi1': 'A4 (29,7 × 21 cm)',
  'print-settings:model-multi1-description': '1 etiqueta por página',
  'print-settings:model-multi3': 'A4 (21 × 29,7 cm)',
  'print-settings:model-multi3-description': '3 etiquetas por página',
  'print-settings:model-multi4': 'A4 (29,7 × 21 cm)',
  'print-settings:model-multi4-description': '4 etiquetas por página',
  'print-settings:print-position:ask-always': 'Perguntar sempre',
  'print-settings:print-position:1': '1.ª posição',
  'print-settings:print-position:2': '2.ª posição',
  'print-settings:print-position:3': '3.ª posição',
  'print-settings:print-position:4': '4.ª posição',
  'print-settings:we-help-you': 'Entre em contacto connosco, nós ajudamos.',
  'print-settings:support-link': 'soporte.web@cttexpress.com',
  'print-settings:download-driver': 'Descarregar driver para impressoras.',
  'print-settings:download-driver-link': 'Driver para impressoras Zebra',
  'print-settings:download-print-manual-title': 'Tem dúvidas?',
  'print-settings:download-print-manual':
    'Pode descarregar o manual de impressão ',
  'print-settings:link-text': 'aqui.',
  // Print alert
  'print-alert:title': 'Imprima as suas etiquetas mais rapidamente',
  'print-alert:description':
    'Imprime muitas etiquetas? Se sim, descarregue a aplicação e imprima as suas etiquetas de forma mais rápida e simples.',
  'print-alert:download-button': 'Descarregar aplicação',
  'print-alert:i-want-know-more': 'Quero saber mais',
  'print-alert:app-not-installed':
    'Parece que ainda não tem a aplicação de impressão instalada. Descarregue‑a para poder imprimir as suas etiquetas.',
  'print-alert:printer-not-configured':
    'Para imprimir as suas etiquetas, é necessário configurar previamente a impressora.',
  'print-alert:cancel-print-alert':
    'Lembre‑se de que apenas é possível descarregar e imprimir etiquetas de envios com o estado “Registado”.',

  // Download Install JSPM App
  'download-install-jspm-app:title': 'Descarregue e instale a App JSPM Client',
  'download-install-jspm-app:explanation':
    'Esta aplicação ajuda‑o a gerir a impressão das suas etiquetas de forma mais rápida e simples. Graças à função de impressão silenciosa, sempre que fizer um pedido de envio, a etiqueta será impressa de imediato com apenas um clique, evitando os passos habituais da impressora.',
  'download-install-jspm-app:alert-license-title': 'Termos e condições',
  'download-install-jspm-app:alert-license-content':
    'Ao clicar em “Descarregar”, está a aceitar o <link>Contrato de Licença do Software e as Políticas de Privacidade da JSPM.</link>',
  'download-install-jspm-app:recommended-version': 'Versão recomendada',
  'download-install-jspm-app:helper-text-instructions':
    'Para configurar a impressão das etiquetas, é necessário ter o software JSPrintManager (JSPM). Leia atentamente as instruções antes de proceder à instalação. Descarregue o software de forma segura e gratuita abaixo.',
  'download-install-jspm-app:alert-recommended-version-not-obtained-content':
    'Não foi possível obter uma versão recomendada para o seu computador. Aceda à página do <link>JSPM Client</link> para encontrar a versão mais adequada ao seu dispositivo.',
  'download-install-jspm-app:url': 'fasd',
  'download-install-jspm-app:other-version':
    'Se precisar de descarregar uma versão diferente da recomendada, aceda à página do <link>JSPM Client</link>.',
  'download-install-jspm-app:installation-instructions':
    'Instruções de instalação',
  'download-install-jspm-app:instructions-name':
    'Manual de instruções {operatingSystem}',
  'download-install-jspm-app:obtaining-installable': 'A obter executável',
  'download-install-jspm-app:obtaining-instructions': 'A obter instruções',

  // Print modal
  'choose-position-print-labels':
    'Escolha a posição a partir da qual pretende iniciar a impressão das etiquetas',
  // TODO: @dev: dinamizar número y plural de palabra etiqueta según cantidad de etiquetas
  'your-are-going-to-print-number-labels':
    'Vai imprimir um total de {shippingsCount, plural, one {1 etiqueta} other {{shippingsCount} etiquetas}}.',
  // TODO: @dev: dinamizar modelo y número de etiquetas
  'alert-print-modal:model-number-of-labels':
    'A4 (29,7 × 21 cm) – 4 etiquetas por página',
  'default-printing-model': 'Modelo de impressão predefinido',
  'change-model-size-on-print-settings':
    'Pode alterar esta seleção nas <link>Definições de impressão</link>',
  'print-modal:label-print-position': 'Posição de impressão',
  'print-modal:print-position-tooltip':
    'Escolha a partir de que posição pretende iniciar a impressão das etiquetas.',
  'print-modal:title': 'Impressão',
  'print-modal:body': 'A etiqueta foi enviada para a impressora',
  'print-modal:first-position': '1.ª posição',
  'print-modal:second-position': '2.ª posição',
  'print-modal:third-position': '3.ª posição',
  'print-modal:fourth-position': '4.ª posição',

  // User zone
  'user-zone:welcome':
    '{name, select, unnamed {Bem‑vindo} other {Bem‑vindo, {name}} }',
  'user-zone:explanation':
    'Aqui pode consultar os seus dados de contacto e atualizar a palavra‑passe.',
  'user-zone:contact-person': 'Pessoa de contacto',
  'user-zone:contact-data': 'Dados de contacto',
  'user-zone:client-code': 'Código de cliente',
  'user-zone:change-contact-data': 'Alterar dados de contacto',
  'user-zone:contact-data-saved': 'Os dados de contacto foram guardados.',
  'user-zone:contact-explanation':
    'São os dados que utilizaremos para o contactar quando necessário. Pode alterá‑los quando quiser. Procure mantê‑los atualizados.',
  'user-zone:password': 'Palavra‑passe',
  'user-zone:passwords-dont-match': 'As palavras‑passe não coincidem.',
  'user-zone:password-must-have-a-number':
    'A palavra‑passe deve ter pelo menos 1 número',
  'user-zone:password-must-have-an-uppercase-letter':
    'A palavra‑passe deve ter pelo menos 1 letra maiúscula',
  'user-zone:confirm-password': 'Confirmar palavra‑passe',
  'user-zone:password-msg-info':
    'Lembre‑se de que a palavra‑passe deve ter, pelo menos, 8 caracteres, 1 maiúscula e 1 número.',
  'user-zone:change-password': 'Alterar palavra‑passe',
  'user-zone:bad-password': 'A palavra‑passe atual não está correta.',
  'user-zone:password-error':
    'Parece que ocorreu um problema. Por favor, tente novamente.',
  'user-zone:password-saved': 'A nova palavra‑passe foi guardada.',

  // Return
  'returns:activate:main-title': 'Pretende solicitar a devolução deste envio?',
  'returns:activate:main-subtitle': 'N.º do envio: {shippingCode}',
  'returns:activate:main-info': 'Passaremos para recolher a sua mercadoria por',
  'returns:activate:confirm-contact-data': 'Confirme os dados de contacto:',

  'returns:activate:activate-return': 'Pretende ativar a Recolha à Carta?',
  'returns:activate:confirm-activate-return':
    'Sim, prefiro que o meu cliente escolha onde e quando pretende entregar a mercadoria',

  'return:activate:action:confirm': 'Sim, devolver mercadoria',
  'return:activate:delivered-email-input': 'Email do remetente',
  'return:activate:delivered-email': 'Email do remetente para notificação:',
  'returns:success:main-title': 'A sua devolução foi solicitada com sucesso',
  'returns:success:alert':
    'Lembre‑se de que, na secção Seguir envio, pode consultar todos os seus envios e respetivos estados.',
  'returns:activate:remember-text':
    '*Lembre‑se de que esta mercadoria será devolvida à morada de origem e implica custos. Mais informações no seu contrato ou junto do seu consultor comercial.',
  'return:success:action:confirm': 'Voltar a seguimento',

  // Unscheduled pickup
  'unscheduled-pickup:main-title': 'Programar recolha',
  'unscheduled-pickup:main-subtitle':
    'Quando pretende que passemos para recolher?',
  'unscheduled-pickup:option:asap': 'O mais cedo possível',
  'unscheduled-pickup:option:chosse-day-and-hour': 'Quero escolher dia e hora',
  'unscheduled-pickup:asap-info':
    'Esta é a data em que os seus volumes serão recolhidos na morada indicada.',
  'unscheduled-pickup:reminder':
    'Lembre‑se de que, quando passarmos para recolher estes envios, poderemos levar todos os volumes que tiver preparados e etiquetados nesse momento.',
  'unscheduled-pickup:confirmation-title':
    'A sua recolha foi programada com sucesso',
  'unscheduled-pickup:confirmation-subtitle':
    'Em breve, as alterações serão visíveis na página de seguimento',
  'unscheduled:success:action:confirm': 'Voltar a seguimento',
  'unscheduled-pickup:date:not-defined':
    'Não definida. Indicaremos a data quando a recolha for programada ou o envio for recolhido.',
  'action:schedule-pickup-option':
    'Programar {count, plural, one {recolha} other {recolhas}}',
  'unscheduled-pickup:table-header-title': 'Morada de origem',

  // My Clients (BK/FR)
  // Traduções adicionadas por Claude (não encontradas no excel de traduções)
  'delivery-point:recommended': 'Recomendado!',
  'switch-label:new-product': 'Novo produto!',
  'switch-label:recommended-product': 'Produto Recomendado!',
  'noun:scaned-albaran': 'Digitalização de Guia de Remessa',
  'noun:albaran-pt': 'GuiaPT',
  'noun:incident-filters': 'Incidências geríveis',
  'error:field:address-autocomplete':
    'Por favor, adicione {missingFields} para continuar.',
  'shipping-send-form:origin:postal-code:invalid-format-pt':
    'Por favor, insira os 7 dígitos do código postal',
  'shipping-send-form:customs:form:price-hint':
    'Este valor pode ser utilizado pela alfândega para calcular impostos e taxas. Insira o valor real.',
  'shipping-send-form:customs:form:price-hint-link': 'Ver mais informações',
  'shipping-send-form:customs:taric-code-ten':
    'Deve conter exatamente 10 dígitos',
  'shipping-detail:return-on-delivery-number': 'Nº envio devolvido:',
  'help:team-viewer-info':
    'Caso necessite de suporte remoto, a nossa equipa técnica solicitará a sua permissão para aceder ao site de clientes remotamente. Será necessário ter instalado um dos seguintes programas:',
  'shipping-state:WEB0200:description': '',
  'shipping-state:WEB0800:description': '',
  'shipping-state:WEB1000:description': '',
  'shipping-state:WEB1300:description': '',
  'shipping-state:WEB1800:description': '',
  'shipping-state:WEB1900:description': '',
  'shipping-state:WEB2100:description': '',
  'shipping-state:WEB2600:description': '',
  'shipping-state:WEB2900:description': '',
  'print-settings:app-jspm-browser-permissions':
    'É necessário conceder permissão ao navegador web para ativar esta funcionalidade.',
  'print-settings:app-jspm-browser-permissions-tooltip':
    'Após as atualizações mais recentes do Google Chrome e do Microsoft Edge, estes navegadores solicitam permissões adicionais para executar a aplicação de impressão, pelo que é necessário autorizar manualmente a sua execução quando o navegador apresentar o aviso correspondente. Se já tiver instalado uma versão anterior do JSPrint Manager, verifique a barra do navegador junto ao domínio web e ative "Permitir aplicações no dispositivo".',
  'noun:my-clients': 'Meus clientes',
  'my-clients:title': 'Meus clientes',
  'my-clients:tab:clients': 'Clientes',
  'my-clients:tab:web-users': 'Utilizadores web',
  'my-clients:clients:search-placeholder':
    'Pesquisar por nome, código personalizado ou código de cliente...',
  'my-clients:clients:empty-state': 'Não foram encontrados clientes',
  'my-clients:clients:add-button': 'Criar novo cliente',
  'my-clients:clients:column:code': 'Código',
  'my-clients:clients:column:name': 'Nome',
  'my-clients:clients:column:contact': 'Contacto',
  'my-clients:clients:column:email': 'Email',
  'my-clients:clients:column:status': 'Estado',
  'my-clients:clients:column:actions': 'Ações',
  'my-clients:clients:section-title': 'Encontre um Cliente',
  'my-clients:clients:action:view': 'Ver mais',
  'my-clients:clients:action:edit': 'Editar',
  'my-clients:users:section-title': 'Configure os seus utilizadores',
  'my-clients:users:section-subtitle': 'Pesquise o seu utilizador aqui',
  'my-clients:users:search-placeholder': 'Pesquisar utilizador...',
  'my-clients:users:empty-state': 'Não foram encontrados utilizadores',
  'my-clients:users:add-button': 'Adicionar utilizador',
  'my-clients:users:column:email': 'Email',
  'my-clients:users:column:centers': 'Centros',
  'my-clients:users:column:status': 'Estado',
  'my-clients:users:column:last-login': 'Último login',
  'my-clients:users:column:role': 'Função',
  'my-clients:users:column:actions': 'Ações',
  'my-clients:users:action:edit': 'Editar',
  'my-clients:users:action:delete': 'Eliminar',
  'my-clients:role:admin': 'Administrador',
  'my-clients:role:gestor': 'Gestor',
  'my-clients:role:colaborador': 'Colaborador',
  'my-clients:client-drawer:title-create': 'Novo cliente',
  'my-clients:client-drawer:title-edit': 'Editar cliente',
  'my-clients:client-drawer:section:center-data': 'Dados do centro',
  'my-clients:client-drawer:section:address': 'Endereço operacional',
  'my-clients:client-drawer:section:contact': 'Dados de contacto',
  'my-clients:client-drawer:section:address-use': 'Usar este endereço para',
  'my-clients:client-drawer:section:returns-address': 'Endereço de devoluções',
  'my-clients:client-drawer:section:pickups-address': 'Endereço de recolhas',
  'my-clients:client-drawer:section:labels-address': 'Endereço de etiquetas',
  'my-clients:client-drawer:field:center-name': 'Nome do centro',
  'my-clients:client-drawer:field:business-name': 'Nome da empresa',
  'my-clients:client-drawer:field:custom-code': 'Código personalizado',
  'my-clients:client-drawer:field:contact-name': 'Nome de contacto',
  'my-clients:client-drawer:field:contact-email': 'Email de contacto',
  'my-clients:client-drawer:field:phone-prefix': 'Prefixo',
  'my-clients:client-drawer:field:contact-phone': 'Telefone',
  'my-clients:client-drawer:field:street': 'Rua',
  'my-clients:client-drawer:field:street-number': 'Número',
  'my-clients:client-drawer:field:city': 'Localidade',
  'my-clients:client-drawer:field:postal-code': 'Código postal',
  'my-clients:client-drawer:field:country': 'País',
  'my-clients:client-drawer:field:use-for-returns': 'Devoluções',
  'my-clients:client-drawer:field:use-for-pickups': 'Recolhas',
  'my-clients:client-drawer:field:use-for-labels': 'Etiquetas',
  'my-clients:client-drawer:action:save': 'Guardar',
  'my-clients:client-drawer:action:cancel': 'Cancelar',
  'my-clients:client-drawer:success-create': 'Cliente criado com sucesso',
  'my-clients:client-drawer:success-edit': 'Cliente atualizado com sucesso',
  'my-clients:client-drawer:error': 'Ocorreu um erro. Tente novamente.',
  'my-clients:user-drawer:title-create': 'Novo utilizador',
  'my-clients:user-drawer:title-edit': 'Editar utilizador',
  'my-clients:user-drawer:field:name': 'Nome',
  'my-clients:user-drawer:field:email': 'Email',
  'my-clients:user-drawer:field:phone': 'Telefone',
  'my-clients:user-drawer:field:role': 'Função',
  'my-clients:user-drawer:field:centers': 'Centros atribuídos',
  'my-clients:user-drawer:action:save': 'Guardar',
  'my-clients:user-drawer:action:cancel': 'Cancelar',
  'my-clients:user-drawer:success-create':
    'Utilizador criado com sucesso. Receberá um email de ativação.',
  'my-clients:user-drawer:success-edit': 'Utilizador atualizado com sucesso',
  'my-clients:user-drawer:error': 'Ocorreu um erro. Tente novamente.',
  'my-clients:user-drawer:admin-centers-info':
    'A função Administrador tem acesso automático a todos os centros.',
  'my-clients:user-drawer:centers-search-placeholder': 'Pesquisar centro...',
  'my-clients:user-drawer:centers-selected': '{count} centros selecionados',
  'my-clients:user-drawer:centers-select-all': 'TODOS',
  'my-clients:delete-user:title': 'Eliminar utilizador',
  'my-clients:delete-user:description':
    'Tem a certeza de que pretende eliminar o utilizador {name}? Esta ação não pode ser anulada.',
  'my-clients:delete-user:action:confirm': 'Sim, eliminar',
  'my-clients:delete-user:action:cancel': 'Cancelar',
  'my-clients:delete-user:success': 'Utilizador eliminado com sucesso',
  'my-clients:delete-user:error': 'Ocorreu um erro ao eliminar o utilizador.',
  'my-clients:detail:tab:info': 'Informação',
  'my-clients:detail:tab:users': 'Utilizadores',
  'my-clients:detail:tab:rates': 'Tarifas',
  'my-clients:detail:tab:pickup': 'Recolha',
  'my-clients:detail:back': 'Voltar aos clientes',
  'my-clients:detail:rates:placeholder':
    'As tarifas estarão disponíveis brevemente.',
  'my-clients:detail:pickup:placeholder':
    'A configuração de recolha estará disponível brevemente.',
  'action:continue': 'Continuar',
  'shipping-send-form:origin:label-customization:customize':
    'Personalizar dados da etiqueta',
  'shipping-send-form:origin:label-customization:drawer-title':
    'Personalize a sua etiqueta',
  'shipping-send-form:origin:label-customization:drawer-title-edit':
    'Editar dados do remetente',
  'shipping-send-form:origin:label-customization:info-title':
    'Dados personalizados da etiqueta',
  'shipping-send-form:origin:label-customization:info-text':
    'Campos personalizados para etiqueta:',
  'shipping-send-form:origin:label-customization:info-description-1':
    'Estes campos serão refletidos na posição do remetente da etiqueta, mas não irão alterar os dados operacionais do envio.',
  'shipping-send-form:origin:label-customization:info-description-2':
    'Se deixar algum campo por preencher, a etiqueta mostrará os dados originais do envio.',
  'shipping-send-form:origin:label-customization:name-label':
    'Nome personalizado para a etiqueta de envio',
  'shipping-send-form:origin:label-customization:address-label':
    'Endereço personalizado para a etiqueta de envio',
  'shipping-send-form:origin:label-customization:custom-name':
    'Nome personalizado',
  'shipping-send-form:origin:label-customization:custom-address':
    'Endereço personalizado',
  'shipping-send-form:origin:label-customization:delete':
    'Eliminar dados personalizados',

  // Tradução adicionada por Claude (não encontrada no excel de traduções)
  'shipping-send-form:shipment:eu-regulation-warning-24h-es-pt':
    'A nova regulamentação europeia aplicável ao transporte internacional pode afetar os prazos de entrega dos envios 24h de Espanha para Portugal.',
}

export default PT
